import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import { MessageHandlerService } from "src/app/services/message-handler.service";
import { AgencyService } from "src/app/services/agency/agency.service";
import { UserDataManager } from "src/app/user/UserDataManager";
import { User, UserStatus } from "src/app/models/user";
import { Table } from "primeng/table";
import { ProgressBarService } from "src/app/services/progress-bar.service";
import {
  eSocPatientSubmissions,
  eSocStatus,
  EsocSubmissionStatusColor,
  EsocSubmissionStatusValues,
  consentStatus,
  eDocComplete,
  hosAddendumStatusOptions,
} from "src/app/models/esocPatient";
import { eSockStatus } from "src/app/models/patientSubmissions";
import { EsocService } from "src/app/services/e-soc/esoc.service";
import { Subscription, firstValueFrom } from "rxjs";
import { environment } from "../../../environments/environment";
import { checkBoxExportValues, tickCheckBoxByExportValue, tickedCheckBoxExportValue } from "../pdf-checkbox.utils";
import * as AWS from "aws-sdk";
import { S3 } from "aws-sdk";
import { SelectItem, ConfirmationService } from "primeng/api";
import { refreshTime } from "src/app/models/patient";
import { countries } from "src/app/models/country-data";
import {
  adminRoles,
  EsignAllowedRoles,
  DATE_PICKER_FORMAT,
  DATE_PICKER_PLACEHOLDER,
  dateAndTimeFormat,
  dateFormat,
  dateFormatStartWithYear,
  dateFormatStartWithYearWithOutDashes,
  DEFAULT_MRN_LENGTH,
  DEFAULT_PATIENT_ID_LENGTH,
  DEFAULT_SEARCH_MIN_CHARACTER,
  FILE_DOWNLOAD_SUCCESS,
  FileType,
  FileTypeNames,
  RoleID,
  rowsPerPageOptions,
  SEARCH_PATIENT_BY_CASE_MANAGER,
  SEARCH_PATIENT_BY_ID,
  SEARCH_PATIENT_BY_MRN,
  EDOC_REPORT,
  EXCEL_TYPE,
  EXCEL_EXTENSION,
  FILE_NOT_OPENED,
  DEBOUNCE_TIME_SET,
  NO_OF_RECORDS_PER_PAGE, DEFAULT_VISIT_DATE_FILTER,
  PDFJS_WORKER_URL,
  OPT_IN,
  OPT_OUT,
  DOB_DATE_FORMAT,
} from "../../common/Constants";
import { endOfToday } from "../../common/calendar-max-date.util";
import { Dropdown } from "primeng/dropdown";
import { DatePipe } from "@angular/common";
import { RoleEnum } from "src/app/models/agency";
import { PatientService } from "src/app/services/patient/patient.service";
import { UserService } from "src/app/services/user.service";
import { Paginator } from "primeng/paginator";
import { NavigationEnd, Router } from "@angular/router";
import { LocalStorageService } from "../../services/local-storage.service";
import { UtilService } from "../../services/util/util.service";
import { Workbook } from "exceljs";
import * as fs from "file-saver";
import { EMPTY, Subject } from "rxjs";
import { catchError, debounceTime, defaultIfEmpty, distinctUntilChanged, map } from "rxjs/operators";
import { HosAddendumService } from "src/app/services/hos-addendum/hos-addendum.service";
import { parseDateOnly } from "src/app/common/date-only.util";

export interface SignerFieldConfig {
  signatureField: string;
  signatureField2: string;
  signatureField3: string;
  signatureField4?: string;
  signatureField5?: string;
  signatureField6?: string;
  signatureField7?: string;
  signatureField8?: string;
  signatureField9?: string;
  signatureField10?: string;
  dateField: string;
  dateField2: string;
  dateField3: string;
  dateField4?: string;
  dateField5?: string;
  dateField6?: string;
  dateField7?: string;
  dateField8?: string;
  dateField9?: string;
  dateField10?: string;
  signatureFieldOptional: boolean;
  signatureField2Optional: boolean;
  signatureField3Optional: boolean;
  signatureField4Optional?: boolean;
  signatureField5Optional?: boolean;
  signatureField6Optional?: boolean;
  signatureField7Optional?: boolean;
  signatureField8Optional?: boolean;
  signatureField9Optional?: boolean;
  signatureField10Optional?: boolean;
  // Non-signature fields (text boxes, checkboxes, radio groups, dropdowns) this signer fills in on the
  // signing page, each assigned to exactly one signer (IOHB-1779).
  fillFields?: EsignFillField[];
}

export interface EsignFillField {
  name: string;
  required?: boolean;
}

@Component({
  selector: "app-esoc",
  templateUrl: "./esoc.component.html",
  styleUrls: ["./esoc.component.scss"],
})
export class EsocComponent implements OnInit, OnDestroy {
  fileNotOpened = FILE_NOT_OPENED;
  esocPatientsData: any[] = [];
  currentUser: User;
  selectedPatients: eSocPatientSubmissions[];
  searchEsocPatient: string = "";
  currentAgency: string;
  totalEsocs: number = 0;
  selectedIndexForPopup: number;
  selectedIndex: any;
  prefferedContact: any;
  currentAgencyRole;
  subscriptions: Subscription[] = [];
  eSocSubmissionStatusColor = EsocSubmissionStatusColor;
  eSocSubmissionStatusValues = EsocSubmissionStatusValues;
  statusOptions: SelectItem[] = eSocStatus;
  hosAddendumStatusOptions: SelectItem[] = hosAddendumStatusOptions;
  consentStatus: SelectItem[] = consentStatus;
  edocComplete: SelectItem[] = eDocComplete;
  selectedStatus: string;
  fileStatus: string;
  consent: boolean | string;
  edocCompleteStatus: boolean | string = 'ALL';
  piReportStatus: string;
  otherStatus: string;
  hosAddendumStatus: string;
  selectedDate: any;
  formatDate;
  status;
  selectedFileTypeFilter: string;
  selectRefreshTime: number = 30;
  refreshTime = refreshTime;
  intervalId: any;
  eSOCUploadType: string;
  eSOCUploadDisplay: boolean = false;
  uploadOthersDisplay: boolean = false;
  selectedEsock: any;
  rangeDates: Date[];
  searchByVisitDates: any = {};
  startDate: any;
  endDate: any;
  RoleEnum = RoleEnum;
  defaultSortField = "activityDate";
  defaultSortOrder = "-1";
  // showcasemanagerNameFilter: boolean = true;
  // caseManagerFilterNames: any;
  selectedCaseManager: any = "All";
  dateFormat = dateFormat;
  dateAndTimeFormat = dateAndTimeFormat;
  adminRoles = adminRoles;
  hidePatientName: boolean = false;
  datePickerFormat = DATE_PICKER_FORMAT;
  maxDate: Date = endOfToday();
  datePickerPlaceholder = DATE_PICKER_PLACEHOLDER;
  searchPatientById = SEARCH_PATIENT_BY_ID;
  searchPatientByMRN = SEARCH_PATIENT_BY_MRN;
  pageNo: number = 0;
  noOfEsocksPerRow: number = NO_OF_RECORDS_PER_PAGE;
  rowsPerPageOptions: number[] = rowsPerPageOptions;
  isChangingPage: boolean = false;
  searchByCaseManager: string = "";
  searchByCaseManagerPlaceHolder = SEARCH_PATIENT_BY_CASE_MANAGER;
  currentRoute: string;
  defaultMrnLength = DEFAULT_MRN_LENGTH;
  defaultPatientIdLength = DEFAULT_PATIENT_ID_LENGTH;
  defaultSearchMinCharacter = DEFAULT_SEARCH_MIN_CHARACTER;
  fileType = FileType;
  companyAdminUser = RoleID.companyAdmin;
  iohAdmin = RoleID.iohAdmin;
  Admin = RoleID.Admin;
  agencyAdmin = RoleID.AgencyAdmin;
  loading: boolean = false;
  workbook: Workbook;

  esignModalDisplay = false;
  hosAddendumModalDisplay = false;
  isHosAddendumFeatureEnabled = false;
  selectedEsocRecordForHos: any = null;
  selectedEsocRecord: any = null;
  selectedTemplates: any[] = [];
  esignSubmissionForm: any = {
    email: { email: "", preferred: true },
    phoneNumber: { countryCode: countries[0].dial_code, number: "", preferred: false },
    dob: "",
    isChecked: false,
  };
  esignEmailList: any[] = [
    { email: "", label: "Email" },
    { email: "", label: "Additional Email" },
    { email: "", label: "Additional Email" },
  ];
  esignPhoneList: any[];
  countries = countries;
  dobDateFormat: string;
  isValidEsignPhone: boolean = true;
  showEsignDobInvalidError: boolean = false;
  isEsignPreferredContactSelected: boolean = false;
  customMessage: string = '';
  esignTemplatesList: any[] = [];
  esignHistories: any[] = [];
  sendingEsign = false;
  autoSaving = false;
  autoSaveStatus: 'idle' | 'saving' | 'saved' = 'idle';
  private autoSaveTimer: any = null;
  loadingEsignData = false;
  loadingEsignHistory = false;
  additionalRecipients: any[] = [];
  savedSigners: any[] = [];
  editingSignerIndex: number | null = null;
  // When editing an ad-hoc signer (added via "Add Signer", not a saved-roster signer),
  // this holds the original signer object so the save handler updates it in place (IOHB-1654).
  editingAdhocSigner: any = null;
  addRecipientModalDisplay = false;
  newRecipient: any = { name: '', email: '', countryCode: countries[0].dial_code, number: '', notificationMethod: 'email' };
  /** Type-ahead matches for the Add Signer name field (IOHB-1779, Story 3). */
  signerSuggestions: any[] = [];
  private readonly signerLookupPageSize = 10;
  /** Bumped on every searchStaffSigners() call and captured per-request, so a response to an
   *  earlier, now-superseded keystroke can never overwrite the suggestions for a later one —
   *  requests race with no cancellation (no switchMap), so ordering on the wire is not
   *  guaranteed to match the order they were sent in. */
  private staffSignerSearchSeq = 0;
  groupedEsignHistories: any[] = [];
  allGroupedEsignHistories: any[] = [];

  fillableFormModalDisplay = false;
  isViewOnlyFillablePdf = false;
  viewOnlySignerTags: any[] = [];
  pdfFormFields: any[] = [];
  selectedTemplateToFill: any = null;
  loadingPdfFields = false;
  savingPdfFields = false;
  originalPdfBytes: ArrayBuffer | null = null;
  filledFormValuesCache: { [key: string]: any[] } = {};
  signerFieldTags: Record<string, SignerFieldConfig> = {};
  templateSignerTagsCache: Record<string, Record<string, SignerFieldConfig>> = {};
  templatePatientSigRequiredCache: Record<string, boolean> = {};
  fillPdfZoomScale: number = 1.0;
  renderingPdfPages = false;
  // A zoom/re-render requested while a render is already in flight; serviced when it finishes.
  pendingReRender = false;
  currentPageScaleMap: { [key: number]: number } = {};
  pdfDocToFill: any = null;
  numPagesToFill: number = 0;
  pagesToFill: number[] = [];
  signersForTagging: any[] = [];
  pdfSignatureFieldsOptions: any[] = [];
  pdfDateFieldsOptions: any[] = [];
  // Form fields of the loaded template that aren't signature spots, by name: 'text box', 'checkbox' or
  // 'choice field' (see signatureSpotProblem). Push buttons and signature fields aren't listed here.
  private nonSignatureFieldKinds: Record<string, string> = {};

  clickedFieldName: string = '';
  clickedPageNumber: number = 1;
  showSignerMenu: boolean = false;
  menuX: number = 0;
  menuY: number = 0;
  isPreparingForSigning: boolean = false;
  selectedFieldName: string | null = null;
  lastAssignedSignerId: string | null = null;
  lastAssignedSlotIndex: Record<string, number> = {};
  annotationIdToFieldNameMap: Record<string, string> = {};
  annotationIdToButtonValueMap: Record<string, string> = {};
  // Own checkbox state map: PDF.js resets inputEl.checked after clicks so we track it ourselves. A pick-one
  // checkbox field (see checkboxExportValues) holds the ticked box's export value, or false (IOHB-1868).
  checkboxStateMap: Record<string, boolean | string> = {};
  // Checkbox fields whose boxes share a name but have different export values (e.g. Yes / No), with those values.
  // Their value is which box is ticked, not just ticked or not (IOHB-1868).
  private checkboxExportValues: Record<string, string[]> = {};
  // IOHB-1779: Patient signature required toggle (defaults to true)
  isPatientSignatureRequired: boolean = true;

  @ViewChild("dt") table: Table;
  @ViewChild("dropdown") dropdown: Dropdown;
  @ViewChild("paginator") paginator: Paginator;

  search = new Subject<string>();
  previousEndDate: Date | null = null;
  // Created At filter (4 Oct): the screen opens with the last 7 days of it and every other filter on All.
  createdRangeDates: Date[] | null = null;
  searchByCreatedDates: { startDate: string; endDate: string } | null = null;
  previousCreatedEndDate: Date | null = null;
  private readonly createdDefaultDays = 7;
  // Saved filters from before these defaults are dropped once, so everyone starts from them.
  private readonly eDocStateVersion = 2;

  constructor(
    private readonly messageHandlerService: MessageHandlerService,
    private readonly userDataManager: UserDataManager,
    private readonly progressBarService: ProgressBarService,
    private readonly esocService: EsocService,
    private readonly datePipe: DatePipe,
    private readonly patientService: PatientService,
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
    private readonly utilService: UtilService,
    private readonly cdr: ChangeDetectorRef,
    private readonly agencyService: AgencyService,
    private readonly confirmationService: ConfirmationService,
    private readonly userService: UserService,
    private readonly hosAddendumService: HosAddendumService,
  ) {
    this.esignPhoneList = [
      { countryCode: countries[0].dial_code, number: "", label: "Phone" },
      { countryCode: countries[0].dial_code, number: "", label: "Additional Phone" },
      { countryCode: countries[0].dial_code, number: "", label: "Additional Phone" },
    ];
    this.dobDateFormat = DOB_DATE_FORMAT;
    this.currentRoute = this.router.url;
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
      }
    });

    this.search.pipe(debounceTime(DEBOUNCE_TIME_SET), distinctUntilChanged()).subscribe((value) => {
      this.searchByPatientOrCaseManager(value);
    });

    this.setDefaultDtRange();
  }

  ngOnInit(): void {
    this.getCurrentUserProfile();
    this.getDataFromLocalStorage();
    this.getSelectedAgency();
    this.hideFromDataRoles();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.stopRefresh();
  }

  // The screen opens with one filter: Created At, the last 7 days (today and the 6 days before, in the
  // user's own time zone). SOC Date starts empty.
  setDefaultDtRange() {
    this.rangeDates = null;
    this.searchByVisitDates = null;
    this.createdRangeDates = this.defaultCreatedRange();
    this.searchByCreatedDates = this.createdRangeFor(this.createdRangeDates);
  }

  defaultCreatedRange(): Date[] {
    const start = new Date();
    start.setDate(start.getDate() - (this.createdDefaultDays - 1));
    return [start, new Date()];
  }

  // The chosen days as exact instants: the user's own midnight to the end of the last day.
  createdRangeFor(dates: Date[] | null): { startDate: string; endDate: string } | null {
    if (!dates?.[0]) return null;
    const start = new Date(dates[0]);
    start.setHours(0, 0, 0, 0);
    const end = new Date(dates[1] || dates[0]);
    end.setHours(23, 59, 59, 999);
    return { startDate: start.toISOString(), endDate: end.toISOString() };
  }

  getDataFromLocalStorage() {
    let eDocState = JSON.parse(this.localStorageService.get("eDocState"));
    if (eDocState && eDocState.version !== this.eDocStateVersion) {
      eDocState = null;
      this.localStorageService.set("eDocState", JSON.stringify({ version: this.eDocStateVersion }));
    }
    this.searchEsocPatient = eDocState?.searchEsocPatient ? eDocState?.searchEsocPatient : "";
    this.searchByCaseManager = eDocState?.searchByCaseManager ? eDocState?.searchByCaseManager : "";
    this.selectedStatus = eDocState?.selectedStatus?.toString() ? eDocState?.selectedStatus : "";
    this.selectedFileTypeFilter = eDocState?.fileType ? eDocState?.fileType : "";
    this.fileStatus = this.selectedFileTypeFilter == this.fileType.file ? this.selectedStatus : "";
    this.piReportStatus = this.selectedFileTypeFilter == this.fileType.piReportFile ? this.selectedStatus : "";
    this.otherStatus = this.selectedFileTypeFilter == this.fileType.otherFile ? this.selectedStatus : "";
    this.hosAddendumStatus = this.selectedFileTypeFilter == this.fileType.hosAddendum ? this.selectedStatus : "";
    this.rangeDates = eDocState?.rangeDates ? [new Date(eDocState.rangeDates[0]), new Date(eDocState.rangeDates[1])] : null;
    this.searchByVisitDates = this.rangeDates ? eDocState?.searchByVisitDates ?? null : null;
    // A Created At range the user chose, or cleared (null), is kept. Otherwise it is the rolling last 7 days,
    // saved marked as the default so the next visit moves it on to the new last 7 days.
    if (eDocState && eDocState.createdRangeDates !== undefined && !eDocState.createdRangeIsDefault) {
      this.createdRangeDates = eDocState.createdRangeDates
        ? [new Date(eDocState.createdRangeDates[0]), new Date(eDocState.createdRangeDates[1])]
        : null;
      this.searchByCreatedDates = this.createdRangeFor(this.createdRangeDates);
    } else {
      this.saveCreatedRange(true);
    }
    this.consent = eDocState?.consent ? eDocState?.consent : this.consentStatus[0]?.value;
    this.edocCompleteStatus = eDocState?.edoc_status ?? 'ALL';
    this.prePopulatePerPage()
  }

  prePopulatePerPage() {
    const global = JSON.parse(this.localStorageService.get("globalPageLimit"));
    if (global) {
      this.noOfEsocksPerRow = global.perPage;
    }
  }

  setDataInLocalStorage(key, value) {
    const eDocState: any = JSON.parse(this.localStorageService.get("eDocState"));
    if (eDocState) {
      eDocState[key] = value;
      this.localStorageService.set("eDocState", JSON.stringify(eDocState));
    } else {
      let eDocNewState: any = { version: this.eDocStateVersion };
      eDocNewState[key] = value;
      this.localStorageService.set("eDocState", JSON.stringify(eDocNewState));
    }
  }

  navigate(path) {
    this.router.navigate([path]);
  }

  getCurrentUserProfile() {
    this.subscriptions.push(
      this.userDataManager.user$.subscribe((res) => {
        this.currentUser = res;
      }),
    );
  }

  getSelectedAgency() {
    this.subscriptions.push(
      this.userDataManager.activeAgencyRole$.subscribe((res) => {
        this.currentAgency = res?.agency;
        this.esocPatientsData = [];
        this.currentAgencyRole = res;
        this.checkHosAddendumFeatureStatus();
        // this.geteSocPatientSubmissions();
      }),
    );
  }

  checkHosAddendumFeatureStatus() {
    if (this.hosAddendumService?.checkHosAddendumEnabled) {
      const agencyIdStr = (() => {
        if (this.currentAgency && typeof this.currentAgency === 'object') {
          return (this.currentAgency as any)._id || (this.currentAgency as any).id;
        }
        return this.currentAgency;
      })();
      this.subscriptions.push(
        this.hosAddendumService.checkHosAddendumEnabled(agencyIdStr).subscribe({
          next: (res: any) => {
            this.isHosAddendumFeatureEnabled = res?.content?.hosAddendumEnabled === true;
            this.cdr.detectChanges();
          },
          error: () => {
            this.isHosAddendumFeatureEnabled = false;
            this.cdr.detectChanges();
          },
        }),
      );
    }
  }

  searchByPatientOrCaseManager(searchParam: string) {
    this.setDataInLocalStorage("searchEsocPatient", this.searchEsocPatient);
    this.setDataInLocalStorage("searchByCaseManager", this.searchByCaseManager);

    if (searchParam === undefined || searchParam === null || searchParam === "") {
      // Back to the first page: without the search the list can have fewer pages than the search had.
      this.pageNo = 0;
      this.setDataInLocalStorage("pageNo", this.pageNo);
      this.geteSocPatientSubmissions();
    } else if (searchParam && searchParam.length >= this.defaultSearchMinCharacter) {
      this.pageNo = 0;
      this.setDataInLocalStorage("pageNo", this.pageNo);
      this.geteSocPatientSubmissions();
    }
  }

  geteSocPatientSubmissions(orderBy?: string, order?: string) {
    if (orderBy && order) {
      this.defaultSortField = orderBy;
      this.defaultSortOrder = order;
    }
    this.progressBarService.setProgressBarVisibility(true);
    this.loading = true;
    this.cdr.detectChanges();
    this.subscriptions.push(
      this.esocService
        .geteSocPatientSubmissions({
          agencyId: this.currentAgency,
          status: this.selectedStatus,
          fileType: this.selectedFileTypeFilter,
          search: this.searchEsocPatient,
          dateRangeSearch: this.searchByVisitDates,
          createdAtRangeSearch: this.searchByCreatedDates,
          //searchByCaseManagerName: this.selectedCaseManager,
          pagination: { pageNumber: this.pageNo, pageSize: this.noOfEsocksPerRow },
          caseManagerSearch: this.searchByCaseManager,
          orderBy: this.defaultSortField,
          order: this.defaultSortOrder,
          consent: this.consent,
          eDocComplete: this.edocCompleteStatus,
        })
        // A failed call ends here too, so the list stops loading instead of spinning: the HTTP wrapper
        // turns some failures into an empty reply that never reaches the handler below, and passes
        // others on as an error. Either way the handler gets null.
        .pipe(
          catchError(() => EMPTY),
          defaultIfEmpty(null),
        )
        .subscribe((res) => {
          if (res?.success) {
            if (res?.content?.hosAddendumEnabled !== undefined) {
              this.isHosAddendumFeatureEnabled = res.content.hosAddendumEnabled === true;
            }
            this.esocPatientsData = res.content.data.map((patient) => {
              const patientFirstName = patient?.patientFirstName ? patient?.patientFirstName : "";
              const patientLastName = patient?.patientLastName ? patient?.patientLastName : "";
              const patientName = (patientFirstName ? patientFirstName : "") + " " + (patientLastName ? patientLastName : "");
              return {
                ...patient,
                patientName: patientName,
              };
            });

            this.mergeFiles();
            this.totalEsocs = res?.content?.totalElements;
            if (!this.isChangingPage) {
              this.changePage();
            }
          }
          this.loading = false;
          this.progressBarService.setProgressBarVisibility(false);
          this.cdr.detectChanges();
        }),
    );
    //}
  }

  mergeFiles() {
    this.esocPatientsData.forEach((esocPatient) => {
      esocPatient.patientEsocData.file = esocPatient?.patientEsocData?.file ? esocPatient?.patientEsocData?.file : [];
      esocPatient.patientEsocData.otherFile = esocPatient?.patientEsocData?.otherFile ? esocPatient?.patientEsocData?.otherFile : [];
      esocPatient.patientEsocData.piReportFile = esocPatient?.patientEsocData?.piReportFile ? esocPatient?.patientEsocData?.piReportFile : [];
      esocPatient.patientEsocData.mergeFiles = esocPatient?.patientEsocData?.file.concat(
        esocPatient.patientEsocData.otherFile,
        esocPatient.patientEsocData.piReportFile,
      );

      esocPatient.patientEsocData.mergeFiles.sort((a, b) => {
        return new Date(b.createdAt as string).getTime() - new Date(a.createdAt as string).getTime();
      });
    });
  }

  downloadEsocPatient(index: number, type) {
    this.selectedIndex = this.esocPatientsData[index];
    if (this.esocPatientsData[index].patientEsocData[type] && this.esocPatientsData[index]?.patientEsocData?.[type][0] != undefined) {
      var tempfileName = this.esocPatientsData[index].patientEsocData[type][0].fileLocation;
      const fileName = this.extractKey(tempfileName);
      console.log("file name: ", fileName);
      // var fileName = 'test68d51f8b-a58a-4855-9764-bf9d5678ed6c.pdf';
      this.downloadPdfFromS3(fileName)
        .then(() => {
          console.log("PDF File downloaded successfully");
        })
        .catch((error) => {
          console.log("Error Downloading File: ", error);
        });
    } else {
      console.log("File Name does not exist in the DB");
      this.messageHandlerService.generateToastMessage("error", "", "File Name does not exist in the DB");
    }
  }

  customSort(event) {
    this.geteSocPatientSubmissions(event?.sortField, event?.sortOrder.toString());
  }

  async downloadPdfFromS3(fileName: string, code?:string): Promise<void> {
    try {
      const params = {
        fileName: fileName,
      };

      if(code){
        params['code'] = code;
      }
      this.esocService.getEPHfileObjectUrl(params).subscribe((res) => {
        if (res.success) {
          const link = document.createElement("a");
          link.href = res.url;
          const lastSlash = fileName.lastIndexOf("/");
          link.download = lastSlash > -1 ? fileName.substring(lastSlash + 1) : fileName;
          link.click();
          console.log("File Successfully Downloaded");
          this.messageHandlerService.generateToastMessage("success", "", FILE_DOWNLOAD_SUCCESS);
        } else {
          console.log("Error Downloading File --> : ", res.message);
          this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + res.message);
        }
      });
    } catch (error) {
      console.log("Error Downloading File: ", error);
      this.messageHandlerService.generateToastMessage("error", "", "Error Downloading File: " + error);
    }
  }

  processEsocRequest(index, type) {
    try {
      this.selectedIndex = this.esocPatientsData[index];
      const phone = this.esocPatientsData[index]?.patientEsocData?.patient?.contactInfo?.phone;
      const email = this.esocPatientsData[index]?.patientEsocData?.patient?.contactInfo?.email;
      this.progressBarService.setProgressBarVisibility(true);
      if (!phone && !email) {
        this.messageHandlerService.generateToastMessage("error", "", "Patient does not have a phone number or email");
        this.progressBarService.setProgressBarVisibility(false);
        return;
      }

      this.sendEsocDocument(this.esocPatientsData[index]._id, type);
    } catch (error) {
      console.log("Error Resending Link: ", error);
      this.progressBarService.setProgressBarVisibility(false);
      this.messageHandlerService.generateToastMessage("error", "Communication error:  ", error);
    }
  }

  /** Sends one ioDoc record's document of the given type, named by the record's id. */
  sendEsocDocument(patientEsocRecordId: string, type) {
    this.progressBarService.setProgressBarVisibility(true);
    const request = { patientEsocRecordId, fileType: type };
    this.subscriptions.push(
      this.esocService
        .processEsocRequest(request, this.currentAgency)
        // A failed call ends here too, so the progress bar does not stay on: the HTTP wrapper turns some
        // failures into an empty reply (it has already shown a message) and passes others on as an error,
        // which is shown here. Either way the handler gets null.
        .pipe(
          catchError((error) => {
            this.messageHandlerService.generateToastMessage("error", "", error?.error?.message || "The document could not be sent. Please try again.");
            return EMPTY;
          }),
          defaultIfEmpty(null),
        )
        .subscribe((res) => {
          this.progressBarService.setProgressBarVisibility(false);
          if (res?.success) {
            this.geteSocPatientSubmissions();
            this.messageHandlerService.generateToastMessage("success", "", `A ${FileTypeNames[type]} Link has been sent successfully`);
          } else if (res) {
            if (res?.statusCode == 403) {
              this.messageHandlerService.generateToastMessage("error", "Access denied", "eDoc feature is disabled for this Agency");
            } else {
              this.messageHandlerService.generateToastMessage("warn", "", res?.errorMessage);
            }
          }
        }),
    );
  }

  changeConsent(rowIndex) {
    this.subscriptions.push(
      this.esocService
        .changeConsent({ id: this.esocPatientsData[rowIndex]?._id, consent: !this.esocPatientsData[rowIndex]?.eSock?.consent })
        .subscribe((res) => {
          if (res?.success) {
            this.esocPatientsData[rowIndex].eSock.consent = !this.esocPatientsData[rowIndex].eSock.consent;
          } else {
            this.messageHandlerService.generateToastMessage("error", "", "Error occurred while changing consent.");
          }
        }),
    );
  }

  onStatusChange(event, type) {
    this.selectedStatus = event.value;
    this.selectedFileTypeFilter = type;
    this.consent = "";
    this.geteSocPatientSubmissions();
    this.setDataInLocalStorage("selectedStatus", this.selectedStatus);
    this.setDataInLocalStorage("fileType", this.selectedFileTypeFilter);
    this.setDataInLocalStorage("consent", this.consent);
    if (this.pageNo) {
      this.pageNo = 0;
      this.setDataInLocalStorage("pageNo", this.pageNo);
      this.paginator?.changePage(this.pageNo);
    }
  }

  consentStatusChange() {
    this.resetFileFilters();
    this.geteSocPatientSubmissions();
    this.setDataInLocalStorage("consent", this.consent);
    this.setDataInLocalStorage("edoc_status", this.edocCompleteStatus);
    if (this.pageNo) {
      this.pageNo = 0;
      this.setDataInLocalStorage("pageNo", this.pageNo);
      this.paginator?.changePage(this.pageNo);
    }
  }

  resetFileFilters() {
    this.selectedStatus = "";
    this.selectedFileTypeFilter = "";
    this.fileStatus = "";
    this.piReportStatus = "";
    this.otherStatus = "";
    this.hosAddendumStatus = "";
    this.setDataInLocalStorage("selectedStatus", this.selectedStatus);
    this.setDataInLocalStorage("fileType", this.selectedFileTypeFilter);
  }

  createTooltip(esocPatientsData) {
    let role = esocPatientsData?.UserdefaultRole
      ? "(" + RoleEnum[esocPatientsData?.UserdefaultRole] + ")"
      : esocPatientsData?.isSuperAdmin
        ? "(" + RoleEnum.SUPER_ADMIN + ")"
        : esocPatientsData?.isIohAdmin
          ? "(" + RoleEnum.IOH_ADMIN + ")"
          : "";

    const caseManagerFirstName = esocPatientsData?.patientEsocData?.patient?.CaseManagerFirstName
      ? esocPatientsData?.patientEsocData?.patient?.CaseManagerFirstName
      : "";
    const caseManagerLastName = esocPatientsData?.patientEsocData?.patient?.CaseManagerLastName
      ? esocPatientsData?.patientEsocData?.patient?.CaseManagerLastName
      : "";
    const userFirstName = esocPatientsData?.UserfirstName ? esocPatientsData?.UserfirstName : "";
    const userLastName = esocPatientsData?.UserlastName ? esocPatientsData?.UserlastName : "";

    let caseManager = `${caseManagerFirstName} ${caseManagerLastName}`;
    let createdDate = `${this.datePipe.transform(esocPatientsData?.patientEsocData?.createdAt, this.dateFormat)}`;

    let res = `<b>Submitted by:</b> ${userFirstName} ${userLastName} <br> ${role} <br>`;
    res = res + `<b>Case Manager:</b> ${caseManager} <br>`;
    res = res + ` <b>Created Date:</b> ${createdDate}`;

    if (this.hidePatientName) {
      return res;
    } else {
      let iohData = `<b>IOH ID:</b> ${esocPatientsData?.patientEsocData?.patient?._id} <br> <b>MRN:</b> ${esocPatientsData?.patientEsocData?.patient?.mrn} <br>`;
      res = iohData + res;
      return res;
    }
  }

  selectVisitDate() {
    let newEndDate: any = "";

    if (this.rangeDates[1]) {
      let endDate = new Date(this.datePipe.transform(this.rangeDates[1], dateFormatStartWithYear));
      newEndDate = new Date(endDate.setHours(23, 59, 59, 999));
    }

    const currentEndDate = this.rangeDates[1];
    const endDateChanged = this.previousEndDate !== currentEndDate && currentEndDate;

    if (endDateChanged)  {
      this.searchByVisitDates = {
        startDate: new Date(this.datePipe.transform(this.rangeDates[0], dateFormatStartWithYear)),
        endDate: newEndDate,
      };
      this.pageNo = 0;
      this.setDataInLocalStorage("rangeDates", this.rangeDates);
      this.setDataInLocalStorage("pageNo", this.pageNo);
      this.setDataInLocalStorage("searchByVisitDates", this.searchByVisitDates);
      this.geteSocPatientSubmissions();
    }
    this.previousEndDate = currentEndDate;
  }

  onChangeRefreshTime() {
    this.stopRefresh();
    this.startRefresh();
  }

  stopRefresh() {
    clearInterval(this.intervalId);
  }

  startRefresh() {
    this.intervalId = setInterval(() => {
      this.geteSocPatientSubmissions();
    }, this.selectRefreshTime * 1000);
  }

  onCalendarClear() {
    this.rangeDates = null;
    this.searchByVisitDates = null;
    this.setDataInLocalStorage("rangeDates", this.rangeDates);
    this.setDataInLocalStorage("searchByVisitDates", this.searchByVisitDates);
    this.geteSocPatientSubmissions();
  }

  selectCreatedDate() {
    const currentEndDate = this.createdRangeDates?.[1] ?? null;
    if (currentEndDate && this.previousCreatedEndDate !== currentEndDate) {
      this.searchByCreatedDates = this.createdRangeFor(this.createdRangeDates);
      this.pageNo = 0;
      this.saveCreatedRange(false);
      this.setDataInLocalStorage("pageNo", this.pageNo);
      this.geteSocPatientSubmissions();
    }
    this.previousCreatedEndDate = currentEndDate;
  }

  private saveCreatedRange(isDefault: boolean) {
    this.setDataInLocalStorage("createdRangeDates", this.createdRangeDates);
    this.setDataInLocalStorage("createdRangeIsDefault", isDefault);
  }

  onCreatedCalendarClear() {
    this.createdRangeDates = null;
    this.searchByCreatedDates = null;
    this.saveCreatedRange(false);
    this.geteSocPatientSubmissions();
  }

  hideFromDataRoles() {
    this.hidePatientName = adminRoles.includes(this.currentUser?.currentUserRole);
  }

  isEsignAllowed(): boolean {
    const role = this.currentAgencyRole?.role || this.currentUser?.currentUserRole;
    return EsignAllowedRoles.includes(role?.toString());
  }

  isHosAddendumAllowed(): boolean {
    const role = this.currentAgencyRole?.role || this.currentUser?.currentUserRole;
    return EsignAllowedRoles.includes(role?.toString()) && this.isHosAddendumFeatureEnabled === true;
  }

  isIOHUser() {
    if (this.currentUser.is_super_admin) {
      return false;
    } else return !(this.currentUser.is_ioh_user && this.currentAgencyRole.role === RoleID.AgencyAdmin);
  }

  openEPHUploadPopup(rowIndex, type) {
    this.eSOCUploadType = type;
    this.eSOCUploadDisplay = true;
    this.selectedEsock = this.esocPatientsData[rowIndex];
    this.selectedIndexForPopup = rowIndex;
  }

  ePHUploadPopupClose() {
    this.eSOCUploadDisplay = false;
  }

  refreshListing(event) {
    this.paginator?.changePage(0);
    this.geteSocPatientSubmissions();
    // IOHB-1971: Save & Send sends the record the dialog saved, by its id. It used to wait for the list
    // to reload and send its first row - another patient whenever the list started with one, and
    // nobody when the list did not load.
    if (event?.type && event?.patientEsocRecordId) {
      this.sendEsocDocument(event.patientEsocRecordId, event.type);
    }
  }

  isSearchEmpty() {
    if (this.searchEsocPatient === undefined || this.searchEsocPatient === null || this.searchEsocPatient === "") {
      this.pageNo = 0;
      this.geteSocPatientSubmissions();
    }
  }

  onlyAdminRoles() {
    return adminRoles.includes(this.currentUser?.currentUserRole);
  }

  paginate(event) {
    if (!this.isChangingPage) {
      this.utilService.setDataInLocalStorage("globalPageLimit", "perPage", event.rows);
      this.pageNo = event.page;
      this.noOfEsocksPerRow = event.rows;
      this.geteSocPatientSubmissions();
    }
  }

  changePage() {
    this.isChangingPage = true;
    setTimeout(() => {
      this.paginator?.changePage(this.pageNo);
      this.isChangingPage = false;
    });
  }

  resetPaginator() {
    this.paginator?.changePageToFirst(event);
  }

  exportReport() {
    const req = {
      agencyId: this.currentAgency,
      status: this.selectedStatus,
      fileType: this.selectedFileTypeFilter,
      search: this.searchEsocPatient,
      dateRangeSearch: this.searchByVisitDates,
      createdAtRangeSearch: this.searchByCreatedDates,
      pagination: { pageNumber: this.pageNo, pageSize: this.noOfEsocksPerRow },
      caseManagerSearch: this.searchByCaseManager,
      orderBy: this.defaultSortField,
      order: this.defaultSortOrder,
    };
    this.subscriptions.push(
      this.esocService.getPatientESOCExportData(req).subscribe((res) => {
        if (res && res.success) {
          this.workbook = new Workbook();
          const worksheet = this.workbook.addWorksheet("Patient eDoc");
          this.generateExcelReportData(res.content.data ?? [], worksheet);
          this.exportExcelReport();
        }
      }),
    );
  }

  generateExcelReportData(data, worksheet) {
    this.addFilterDatesRow(worksheet);
    if (data && data?.length > 0) {
      this.prepareEDocDataWithHeaders(data, worksheet);
    }
  }

  addFilterDatesRow(worksheet) {
    let dateRangeString = "";
    let titleString = "";
    let filterRow;
    if (this.searchByVisitDates?.startDate && !this.searchByVisitDates?.endDate) {
      const startDate = this.datePipe.transform(this.rangeDates[0], dateFormatStartWithYear);
      const endDate = this.datePipe.transform(new Date().toISOString(), dateFormatStartWithYear);
      dateRangeString = `Date Range: ${startDate} - ${endDate}`;
    } else if (this.searchByVisitDates?.startDate && this.searchByVisitDates?.endDate) {
      const startDate = this.datePipe.transform(this.rangeDates[0], dateFormatStartWithYear);
      const endDate = this.datePipe.transform(this.rangeDates[1], dateFormatStartWithYear);
      dateRangeString = `Date Range: ${startDate} - ${endDate}`;
    } else if (!this.searchByVisitDates?.startDate && !this.searchByVisitDates?.endDate) {
      const startDate = this.datePipe.transform(new Date().toISOString(), dateFormatStartWithYear);
      dateRangeString = `Date Range: ---- - ${startDate}`;
    }

    titleString = `Report: ${EDOC_REPORT}`;

    filterRow = worksheet.addRow([titleString]);
    worksheet.mergeCells(`A${filterRow.number}:Z${filterRow.number}`);
    filterRow = worksheet.addRow([dateRangeString]);
    worksheet.mergeCells(`A${filterRow.number}:Z${filterRow.number}`);
    worksheet.addRow([]);
  }

  prepareEDocDataWithHeaders(data, worksheet) {
    this.addHeaders(worksheet);
    this.addData(data, worksheet);
  }

  addHeaders(worksheet) {
    let headers = this.getReportHeaders();
    this.addHeaderRow(headers, worksheet);
  }

  getReportHeaders() {
    const headers = [
      { header: "MRN", key: "MRN", width: 30 },
      { header: this.hidePatientName ? "Patient ID" : "Patient Name", key: this.hidePatientName ? "Patient ID" : "Patient Name", width: 50 },
      { header: "Edoc Status", key: "Edoc Status", width: 30 },
      { header: "File name", key: "File name", width: 50 },
      { header: "File Type", key: "File Type", width: 30 },
      { header: "Preferred Method", key: "Preferred Method", width: 20 },
      { header: "Sender", key: "Sender", width: 30 },
      { header: "Send (Date)", key: "Send (Date)", width: 30 },
      { header: "Received", key: "Received", width: 30 },
      { header: "Status", key: "Status", width: 30 },
    ];
    // IOHB-1825: the patient's current HOS Addendum, for agencies that use the feature
    if (this.isHosAddendumAllowed()) {
      headers.push(
        { header: "Addendum", key: "Addendum", width: 15 },
        { header: "Addendum Sent", key: "Addendum Sent", width: 18 },
        { header: "Addendum Signed/Expired", key: "Addendum Signed/Expired", width: 25 },
        { header: "Addendum Sends", key: "Addendum Sends", width: 18 },
        { header: "Addendum Last Sent", key: "Addendum Last Sent", width: 25 },
      );
    }
    return headers;
  }

  /** IOHB-1825: the export's Addendum columns, from the patient's current HOS Addendum. */
  hosAddendumExportValues(element: any): (string | number)[] {
    const addendum = element?.latestHosAddendum;
    if (!addendum) {
      return ["", "", "", "", ""];
    }
    const status = this.hosAddendumStatusLabel(addendum.status, addendum.deliveryStatus);
    const endedAt = status === "Signed" ? addendum.signedAt : status === "Expired" ? addendum.terminalStateReachedAt : null;
    const lastSentAt = addendum.lastAlertSentAt || addendum.sentAt;
    return [
      status,
      addendum.sentAt ? this.datePipe.transform(addendum.sentAt, dateFormat) : "",
      endedAt ? this.datePipe.transform(endedAt, dateFormat) : "",
      addendum.totalSendCount || 0,
      lastSentAt ? this.datePipe.transform(lastSentAt, dateAndTimeFormat) : "",
    ];
  }

  addHeaderRow(headers, worksheet) {
    const headerRowValues = headers?.map((obj) => obj.key);
    let headersRow = worksheet.addRow(headerRowValues);
    headersRow.eachCell((row, colNumber) => {
      row.style = {
        font: { bold: true },
        fill: {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" },
          bgColor: { argb: "FFFF00" },
        },
      };
    });
    headers?.forEach((header, index) => {
      const column = worksheet.getColumn(index + 1); // Columns are 1-indexed
      column.width = header.width; // Set the width from the response
      column.alignment = { vertical: "middle", horizontal: "left" };
    });
  }

  addData(data, worksheet) {
    let formattedData = [];
    const withHosAddendum = this.isHosAddendumAllowed();
    data.forEach((element) => {
      const hosAddendum = withHosAddendum ? this.hosAddendumExportValues(element) : [];
      element.file = element?.file ? element?.file : [];
      element.otherFile = element?.otherFile ? element?.otherFile : [];
      element.piReportFile = element?.piReportFile ? element?.piReportFile : [];
      element.mergeFiles = element?.file.concat(element.otherFile, element.piReportFile);

      element.mergeFiles.sort((a, b) => {
        return new Date(b.createdAt as string).getTime() - new Date(a.createdAt as string).getTime();
      });

      const preferredMethod =
        element?.eSocEmailPhonePreference?.email?.preferred && element?.eSocEmailPhonePreference?.phone?.preferred
          ? "both"
          : element?.eSocEmailPhonePreference?.email?.preferred
            ? "email"
            : element?.eSocEmailPhonePreference?.phone?.preferred
              ? "phone"
              : "";

      if (element.mergeFiles && element.mergeFiles.length) {
        element.mergeFiles.forEach((mergeFile) => {
          const dataObj = {
            mrn: this.addPatientMrnColumn(element),
            patient: this.addPatientIdOrPatientNameColumn(element),
            estatus: this.addEdocStatusColumn(element),
            filename: mergeFile ? mergeFile?.fileOriginalName : "",
            file_type: mergeFile ? mergeFile?.fileType : "",
            prefer_method: preferredMethod,
            sender:
              (element?.user
                ? element?.user?.firstName + " " + element?.user?.lastName
                : element?.sentuser
                  ? element?.sentuser?.firstName + " " + element?.sentuser?.lastName
                  : "") || "",
            date: mergeFile?.activityDate ? this.datePipe.transform(mergeFile?.activityDate, dateFormat) : "",
            recieved: (mergeFile?.recieved === true ? "Yes" : "No") || "",
            status: (mergeFile?.status ? mergeFile?.status : this.fileNotOpened) || "",
            hos_addendum: hosAddendum,
          };
          formattedData.push(dataObj);
        });
      } else {
        const dataObj = {
          mrn: this.addPatientMrnColumn(element),
          patient: this.addPatientIdOrPatientNameColumn(element),
          estatus: this.addEdocStatusColumn(element),
          filename: "",
          file_type: "",
          prefer_method: preferredMethod,
          sender: "",
          date: "",
          recieved: "",
          status: "",
          hos_addendum: hosAddendum,
        };
        formattedData.push(dataObj);
      }
    });

    formattedData.forEach((e) => {
      const r = [e.mrn, e.patient, e.estatus, e.filename, e.file_type, e.prefer_method, e.sender, e.date, e.recieved, e.status, ...e.hos_addendum];
      worksheet.addRow(r);
    });
  }

  exportExcelReport() {
    this.workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: EXCEL_TYPE });
      let titleString = `${EDOC_REPORT}-`;
      fs.saveAs(blob, titleString + this.datePipe.transform(new Date(), dateFormatStartWithYearWithOutDashes) + EXCEL_EXTENSION);
    });
  }

  addPatientMrnColumn(patient) {
    return !this.hidePatientName ? patient?.patientMrn : "";
  }

  addPatientIdOrPatientNameColumn(patient) {
    if (this.hidePatientName) {
      return patient?.patientId;
    } else {
      const patientFirstName = patient?.patientFirstName;
      const patientLastName = patient?.patientLastName;
      let patientName;
      if (patientFirstName && patientLastName) {
        patientName = patientLastName + " " + patientFirstName;
      } else if (patientLastName) {
        patientName = patientLastName;
      } else if (patientFirstName) {
        patientName = patientFirstName;
      }
      return patientName;
    }
  }

  addEdocStatusColumn(patient) {
    const edocStatus = patient.consent ? OPT_IN : OPT_OUT;
    return edocStatus;
  }

  getEsignCountryCode() {
    let phoneNumber = this.selectedEsocRecord?.patientEsocData?.patient?.contactInfo?.phone;
    let differnce = phoneNumber?.length - 10;
    phoneNumber = phoneNumber?.slice(0, differnce);
    return phoneNumber || '+1';
  }

  getEsignPhoneNumber() {
    let phoneNumber = this.selectedEsocRecord?.patientEsocData?.patient?.contactInfo?.phone;
    let differnce = phoneNumber?.length - 10;
    phoneNumber = phoneNumber?.slice(differnce);
    return phoneNumber || '';
  }

  initEsignEmailAndPhoneLists() {
    const eSocData = this.selectedEsocRecord?.patientEsocData;
    const emailPref = eSocData?.eSocEmailPhonePreference?.email;
    const emailLabels = ["Email", "Additional Email", "Additional Email"];
    const emailValues = [
      emailPref?.email || "",
      emailPref?.primaryEmail || "",
      emailPref?.secondaryEmail || "",
    ];
    this.esignEmailList = emailLabels.map((label, i) => ({ email: emailValues[i] || "", label }));

    const phonePref = eSocData?.eSocEmailPhonePreference?.phone;
    const defaultCode = countries[0].dial_code;
    const phoneLabels = ["Phone", "Additional Phone", "Additional Phone"];
    const phoneValues = [
      { countryCode: phonePref?.countryCode || this.esignSubmissionForm?.phoneNumber?.countryCode || defaultCode, number: phonePref?.number || this.esignSubmissionForm?.phoneNumber?.number || "" },
      { countryCode: phonePref?.primaryCountryCode || defaultCode, number: phonePref?.primaryNumber || "" },
      { countryCode: phonePref?.secondaryCountryCode || defaultCode, number: phonePref?.secondaryNumber || "" },
    ];
    this.esignPhoneList = phoneLabels.map((label, i) => ({ countryCode: phoneValues[i].countryCode, number: phoneValues[i].number, label }));
  }

  changeEsignCheckboxValue() {
    if (this.esignSubmissionForm?.email?.preferred && this.esignSubmissionForm?.phoneNumber?.preferred) {
      this.isEsignPreferredContactSelected = true;
    } else if (!this.esignSubmissionForm?.email?.preferred && !this.esignSubmissionForm?.phoneNumber?.preferred) {
      this.isEsignPreferredContactSelected = false;
    } else if (!this.esignSubmissionForm?.email?.preferred && this.esignSubmissionForm?.phoneNumber?.preferred) {
      this.isEsignPreferredContactSelected = true;
    } else if (this.esignSubmissionForm?.email?.preferred && !this.esignSubmissionForm?.phoneNumber?.preferred) {
      this.isEsignPreferredContactSelected = false;
    }
    this.isEsignEmailMandatory();
    this.isEsignPhoneNumberValid();
  }

  isEsignEmailMandatory() {
    return this.esignSubmissionForm?.email?.preferred;
  }

  isEsignPhoneNumberValid(event?, index?: number) {
    if (this.esignSubmissionForm?.phoneNumber?.preferred) {
      this.isValidEsignPhone = this.esignPhoneList.every((entry, i) => {
        if (entry.number?.length > 0) {
          let phone = entry.number;
          if (phone?.includes("-")) {
            phone = phone.split("-").join("");
          }
          return new RegExp("^[0-9]{10}$").test(phone);
        }
        return i > 0;
      });
    } else {
      this.isValidEsignPhone = true;
    }
    return this.isValidEsignPhone;
  }

  isEsignDobValid() {
    if (this.esignSubmissionForm.dob) {
      let transformedDate = this.datePipe.transform(this.esignSubmissionForm.dob, "MM/dd/yyyy");
      let currentDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
      if (new Date(transformedDate) > new Date(currentDate)) {
        this.showEsignDobInvalidError = true;
      } else {
        this.showEsignDobInvalidError = false;
      }
    }
  }

  formatEsignDate() {
    // The fallback is the patient's stored date of birth, a string: read it as a calendar date, not an instant.
    let dob = this.esignSubmissionForm?.dob ? this.esignSubmissionForm?.dob : parseDateOnly(this.selectedEsocRecord?.patientEsocData?.patient?.dob);
    // With no date to send, send none, so a draft save leaves the stored date of birth as it is.
    // new Date(null) is 1 January 1970, and the save writes whatever is sent onto the patient.
    if (!dob) {
      return undefined;
    }
    let formattedDate = this.utilService.toLocal(dob);
    return this.datePipe.transform(formattedDate, "MM/dd/yyyy");
  }

  openHosAddendumModal(rowIndex: number) {
    this.selectedEsocRecordForHos = this.esocPatientsData[rowIndex];
    this.hosAddendumModalDisplay = true;
  }

  /**
   * The ioDoc column: Complete only when the record is marked so. A record LogShip created has no
   * eDocComplete at all; it is not complete, and the Incomplete filter lists it, so it says Incomplete.
   */
  eDocStatusLabel(esocPatientsData: any): string {
    return esocPatientsData?.patientEsocData?.eDocComplete === true ? "Complete" : "Incomplete";
  }

  getHosAddendumButtonLabel(esocPatientsData: any): string {
    const latestHos =
      esocPatientsData?.latestHosAddendum ||
      esocPatientsData?.patientEsocData?.latestHosAddendum;
    if (latestHos) {
      return this.hosAddendumStatusLabel(latestHos.status, latestHos.deliveryStatus);
    }

    const hosFiles = esocPatientsData?.patientEsocData?.hosAddendumFiles;
    if (hosFiles && hosFiles.length > 0) {
      const active = hosFiles.find((f: any) => f.docState !== 'history') || hosFiles[0];
      return this.hosAddendumStatusLabel(active.status, active.deliveryStatus);
    }
    return 'Upload';
  }

  /** IOHB-1825: the status the HOS Addendum column shows for the patient's current addendum. */
  hosAddendumStatusLabel(status: string, deliveryStatus?: string): string {
    switch (status) {
      case 'signed':
      case 'completed':
        return 'Signed';
      case 'sent':
      case 'pending':
        // An addendum whose email bounced is waiting on the sender, not on the recipient (IOHB-1831).
        return deliveryStatus === 'failed' ? 'Failed' : 'Active';
      case 'expired':
        return 'Expired';
      case 'superseded':
        return 'Superseded';
      default:
        return 'Not sent';
    }
  }

  onHosAddendumUpdated(event?: any) {
    this.geteSocPatientSubmissions();
  }

  openEsignModal(rowIndex: number) {
    if (!this.isEsignAllowed()) {
      this.messageHandlerService.generateToastMessage("error", "Error", "You do not have permission to access the E-Sign feature.");
      return;
    }
    this.filledFormValuesCache = {};
    this.templateSignerTagsCache = {};
    this.fillPdfZoomScale = 1.0;
    this.autoSaveStatus = 'idle';
    this.autoSaving = false;
    if (this.autoSaveTimer) { clearTimeout(this.autoSaveTimer); this.autoSaveTimer = null; }
    this.selectedEsocRecord = this.esocPatientsData[rowIndex];
    this.esignModalDisplay = true;
    this.selectedTemplates = [];
    this.customMessage = '';
    this.esignHistories = [];
    this.additionalRecipients = [];
    this.groupedEsignHistories = [];

    const rawSigners = this.selectedEsocRecord?.patientEsocData?.patient?.esignSigners || [];
    this.savedSigners = [...rawSigners].sort((a: any, b: any) => {
      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });

    const eSoc = this.selectedEsocRecord?.patientEsocData;
    // A date of birth is a calendar date. new Date('1950-05-14') is midnight UTC, which reads as the
    // day before for any agency user behind UTC — so the modal showed, and sent, the wrong day.
    const dob: Date | null = parseDateOnly(this.selectedEsocRecord?.patientEsocData?.patient?.dob);
    // Pre-check "Send via Email" only when the patient actually has an email on
    // file (and hasn't explicitly declined it). The old `preferred !== false`
    // default pre-checked it for EVERY patient, which made the required-but-empty
    // email field silently invalidate the whole form for phone-only patients —
    // disabling Save/Save & Send with no visible reason.
    const storedEsignEmail = this.selectedEsocRecord?.patientEsocData?.eSocEmailPhonePreference?.email?.email;
    this.esignSubmissionForm = {
      isChecked: this.selectedEsocRecord?.patientEsocData?.patient?.contactInfo?.consent,
      email: {
        email: storedEsignEmail,
        preferred:
          this.selectedEsocRecord?.patientEsocData?.eSocEmailPhonePreference?.email?.preferred !== false &&
          !!storedEsignEmail?.trim(),
      },
      phoneNumber: {
        countryCode: this.getEsignCountryCode(),
        number: this.getEsignPhoneNumber(),
        preferred: this.selectedEsocRecord?.patientEsocData?.eSocEmailPhonePreference?.phone?.preferred || false,
      },
      dob,
    };
    this.initEsignEmailAndPhoneLists();
    this.changeEsignCheckboxValue();

    // Load templates and history in parallel
    const agencyIdStr = (() => {
      if (this.currentAgency && typeof this.currentAgency === 'object') {
        return (this.currentAgency as any)._id || (this.currentAgency as any).id;
      }
      if (this.currentAgency) {
        return this.currentAgency;
      }
      // Fallback for company admin: use agency from the selected esoc record
      return this.selectedEsocRecord?.patientEsocData?.patient?.agencyId;
    })();

    const esocRecordId = this.selectedEsocRecord?.patientEsocData?._id;

    this.esignTemplatesList = [];
    if (agencyIdStr) {
      this.loadingEsignData = true;

      // Load agency templates
      this.agencyService.getAgencyTemplates(agencyIdStr).subscribe({
        next: (res) => {
          if (res?.success && res.content?.data) {
            const getDocTimestamp = (doc: any) => {
              if (doc.createdAt) return new Date(doc.createdAt).getTime();
              const match = doc.fileName?.match(/\b(\d{13})\b/);
              if (match) return parseInt(match[1], 10);
              return 0;
            };
            this.esignTemplatesList = (res.content.data || [])
              .slice()
              .sort((a: any, b: any) => getDocTimestamp(b) - getDocTimestamp(a));
          }
          this.loadingEsignData = false;
          this.restoreLatestDraft();
        },
        error: () => {
          this.loadingEsignData = false;
          this.restoreLatestDraft();
        }
      });
    }

    // Load esign history from dedicated endpoint (not from listing data)
    if (esocRecordId) {
      this.loadingEsignHistory = true;
      this.esocService.getEsignHistory(esocRecordId).subscribe({
        next: (res) => {
          this.loadingEsignHistory = false;
          if (res?.success) {
            const history = res.data || [];
            history.sort((a: any, b: any) => {
              const dateA = a.sentAt ? new Date(a.sentAt).getTime() : 0;
              const dateB = b.sentAt ? new Date(b.sentAt).getTime() : 0;
              return dateB - dateA;
            });
            this.esignHistories = history;
            this.groupEsignHistory();
          }
          this.restoreLatestDraft();
        },
        error: () => {
          this.loadingEsignHistory = false;
          this.esignHistories = [];
          this.groupedEsignHistories = [];
          this.restoreLatestDraft();
        }
      });
    }
  }

  /** A parsed phone remainder is only usable once it's a complete 10-digit number —
   *  a bare/leftover country code (e.g. "+1") must never be reused as the number,
   *  or countryCode+number gets concatenated back into "+1+1" (IOHB-1632 feedback). */
  private isCompletePhoneNumber(num: string): boolean {
    return !!num && num.replace(/\D/g, '').length === 10;
  }

  restoreLatestDraft() {
    if (this.loadingEsignData || this.loadingEsignHistory) return;
    if (!this.allGroupedEsignHistories || this.allGroupedEsignHistories.length === 0) return;

    // Only restore an actual DRAFT group — never pre-fill the form from a group that
    // was already sent. Pick the most recent group that still contains draft items.
    const latestGroup = this.allGroupedEsignHistories.find(
      (g: any) => g?.items?.some((i: any) => i.status === 'draft')
    );
    if (!latestGroup || !latestGroup.items || latestGroup.items.length === 0) return;

    console.log("restoreLatestDraft: Restoring draft state from group key", latestGroup.key);

    setTimeout(() => {
      // 1. Restore additionalRecipients list (excludes the patient)
      const parsedRecipients: any[] = [];
      const processedSigners = new Set<string>();
      // Maps each recipient's name+contact identity key to its index in parsedRecipients, so
      // step 2 below can re-derive the same identity instead of matching on name alone — two
      // recipients (e.g. a POA and the patient) can otherwise legitimately share a name.
      const signerKeyToRecipientIndex = new Map<string, number>();

      latestGroup.items.forEach((item: any) => {
        if (item.isPatient) {
          // Restore patient communication preferences
          this.esignSubmissionForm.isChecked = true;
          if (item.notificationMethod === 'email' || item.notificationMethod === 'both') {
            this.esignSubmissionForm.email.preferred = true;
            if (this.esignEmailList.length > 0) {
              const emails = (item.patientEmail || '').split(',').map((e: string) => e.trim());
              emails.forEach((emailVal, index) => {
                if (index < this.esignEmailList.length && emailVal) {
                  this.esignEmailList[index].email = emailVal;
                }
              });
            }
          }
          if (item.notificationMethod === 'phone' || item.notificationMethod === 'both') {
            this.esignSubmissionForm.phoneNumber.preferred = true;
            if (this.esignPhoneList.length > 0) {
              const phones = (item.recipientPhone || '').split(',').map((p: string) => p.trim());
              phones.forEach((phoneVal, index) => {
                if (index < this.esignPhoneList.length && phoneVal) {
                  let phoneNum = phoneVal;
                  let countryCode = countries[0].dial_code;
                  for (const c of countries) {
                    if (phoneNum.startsWith(c.dial_code)) {
                      countryCode = c.dial_code;
                      phoneNum = phoneNum.substring(c.dial_code.length).trim();
                      break;
                    }
                  }
                  this.esignPhoneList[index].number = this.isCompletePhoneNumber(phoneNum) ? phoneNum : '';
                  this.esignPhoneList[index].countryCode = countryCode;
                }
              });
            }
          }
        } else {
          const uniqueKey = `${item.recipientName?.trim().toLowerCase()}_${(item.patientEmail || item.recipientPhone || '').trim().toLowerCase()}`;
          if (!processedSigners.has(uniqueKey)) {
            processedSigners.add(uniqueKey);
            signerKeyToRecipientIndex.set(uniqueKey, parsedRecipients.length);

            let signerPhone = item.recipientPhone || '';
            let countryCode = countries[0].dial_code;
            let phoneNum = signerPhone;
            for (const c of countries) {
              if (signerPhone.startsWith(c.dial_code)) {
                countryCode = c.dial_code;
                phoneNum = signerPhone.substring(c.dial_code.length).trim();
                break;
              }
            }

            parsedRecipients.push({
              name: item.recipientName,
              email: item.patientEmail || '',
              number: this.isCompletePhoneNumber(phoneNum) ? phoneNum : '',
              countryCode: countryCode,
              notificationMethod: item.notificationMethod || 'email',
              isPatient: false
            });
          }
        }
      });

      this.additionalRecipients = parsedRecipients;

      // 2. Restore templates selection and their pre-filled state/cache tags
      // Clear previously selected templates
      this.selectedTemplates = [];

      this.esignTemplatesList.forEach((t: any) => {
        const matchingFile = latestGroup.items.find((item: any) => item.fileOriginalName === t.fileOriginalName);
        if (matchingFile) {
          // If the saved file name contains '-filled-', it was custom pre-filled
          const isFilled = !!matchingFile.fileName && matchingFile.fileName.includes('-filled-');
          if (isFilled) {
            t.filledCustomFile = {
              fileOriginalName: matchingFile.fileOriginalName,
              fileName: matchingFile.fileName,
              fileLocation: matchingFile.fileLocation,
              isFilledCustom: true
            };
          }

          // Add to selected templates list
          this.selectedTemplates.push(t);

          // Reconstruct signer tags cache for this template
          const tags: Record<string, any> = {};
          const signersList = this.getSignersForTagging();

          latestGroup.items.forEach((f: any) => {
            if (f.fileOriginalName === t.fileOriginalName) {
              // Match by identity, not display name — a POA/guardian can legitimately share
              // the patient's name. The patient is always unambiguous; a non-patient signer is
              // re-identified via the same name+contact key used to de-duplicate recipients above.
              let matchedSigner: any;
              if (f.isPatient) {
                matchedSigner = signersList.find(s => s.isPatient);
              } else {
                const fKey = `${f.recipientName?.trim().toLowerCase()}_${(f.patientEmail || f.recipientPhone || '').trim().toLowerCase()}`;
                const recipientIdx = signerKeyToRecipientIndex.get(fKey);
                matchedSigner = recipientIdx != null ? signersList.find(s => s.recipientIndex === recipientIdx) : undefined;
              }
              if (matchedSigner) {
                tags[matchedSigner.id] = {
                  signatureField: f.signatureFieldName || '',
                  signatureField2: f.signatureFieldName2 || '',
                  signatureField3: f.signatureFieldName3 || '',
                  signatureField4: f.signatureFieldName4 || '',
                  signatureField5: f.signatureFieldName5 || '',
                  signatureField6: f.signatureFieldName6 || '',
                  signatureField7: f.signatureFieldName7 || '',
                  signatureField8: f.signatureFieldName8 || '',
                  signatureField9: f.signatureFieldName9 || '',
                  signatureField10: f.signatureFieldName10 || '',
                  dateField: f.dateField || f.dateFieldName || '',
                  dateField2: f.dateField2 || f.dateFieldName2 || '',
                  dateField3: f.dateField3 || f.dateFieldName3 || '',
                  dateField4: f.dateField4 || f.dateFieldName4 || '',
                  dateField5: f.dateField5 || f.dateFieldName5 || '',
                  dateField6: f.dateField6 || f.dateFieldName6 || '',
                  dateField7: f.dateField7 || f.dateFieldName7 || '',
                  dateField8: f.dateField8 || f.dateFieldName8 || '',
                  dateField9: f.dateField9 || f.dateFieldName9 || '',
                  dateField10: f.dateField10 || f.dateFieldName10 || '',
                  signatureFieldOptional: !!f.signatureFieldNameOptional,
                  signatureField2Optional: !!f.signatureFieldName2Optional,
                  signatureField3Optional: !!f.signatureFieldName3Optional,
                  signatureField4Optional: !!f.signatureFieldName4Optional,
                  signatureField5Optional: !!f.signatureFieldName5Optional,
                  signatureField6Optional: !!f.signatureFieldName6Optional,
                  signatureField7Optional: !!f.signatureFieldName7Optional,
                  signatureField8Optional: !!f.signatureFieldName8Optional,
                  signatureField9Optional: !!f.signatureFieldName9Optional,
                  signatureField10Optional: !!f.signatureFieldName10Optional,
                  fillFields: this.copyFillFields(f.fillFields)
                };
              }
            }
          });

          this.templateSignerTagsCache[t.fileName] = tags;

          // The "Patient signature required" setting isn't saved, so rebuild it from the saved mapping: when another
          // signer has a signature spot and the patient has none, the document was prepared with the patient not
          // signing (saving refuses a missing patient signature otherwise). Nothing mapped: keep the default (IOHB-1865).
          const patientSigner = signersList.find((s: any) => s.isPatient);
          if (patientSigner) {
            if (this.hasSignatureSpot(tags[patientSigner.id])) {
              this.templatePatientSigRequiredCache[t.fileName] = true;
            } else if (Object.keys(tags).some(id => id !== patientSigner.id && this.hasSignatureSpot(tags[id]))) {
              this.templatePatientSigRequiredCache[t.fileName] = false;
            }
          }
        }
      });

      // Make a copy of selectedTemplates array to trigger change detection
      this.selectedTemplates = [...this.selectedTemplates];

      this.changeEsignCheckboxValue();
      this.isEsignDobValid();
      this.cdr.detectChanges();
    }, 100);
  }

  groupEsignHistory() {
    const groupedMap = new Map<string, any>();
    this.esignHistories.forEach(item => {
      const key = item.sendGroupId || item.fileOriginalName || item.fileName || 'Document';
      if (!groupedMap.has(key)) {
        groupedMap.set(key, {
          key: key,
          fileNames: '',
          sentAt: item.sentAt,
          items: []
        });
      }
      const groupData = groupedMap.get(key);
      groupData.items.push(item);

      // Track the earliest sentAt date for the group
      if (item.sentAt && groupData.sentAt) {
        if (new Date(item.sentAt).getTime() < new Date(groupData.sentAt).getTime()) {
          groupData.sentAt = item.sentAt;
        }
      } else if (item.sentAt) {
        groupData.sentAt = item.sentAt;
      }
    });

    const fullGroups = Array.from(groupedMap.values()).map((g: any) => {
      // Set the grouped file names (joining unique ones with commas)
      const uniqueNames = Array.from(new Set(g.items.map((item: any) => item.fileOriginalName || item.fileName || 'Document').filter(Boolean)));
      g.fileNames = uniqueNames.join(', ');

      const signedItems = g.items.filter((item: any) => item.status === 'signed' && item.signedFileLocation);
      let latestSignedItem = null;
      if (signedItems.length > 0) {
        signedItems.sort((a: any, b: any) => {
          const dateA = a.signedAt ? new Date(a.signedAt).getTime() : 0;
          const dateB = b.signedAt ? new Date(b.signedAt).getTime() : 0;
          return dateB - dateA;
        });
        latestSignedItem = signedItems[0];
      }

      const isCompleted = g.items.every((item: any) => item.status === 'signed');

      return {
        ...g,
        latestSignedItem,
        isCompleted
      };
    }).sort((a: any, b: any) => {
      const dateA = a.sentAt ? new Date(a.sentAt).getTime() : 0;
      const dateB = b.sentAt ? new Date(b.sentAt).getTime() : 0;
      return dateB - dateA;
    });

    this.allGroupedEsignHistories = fullGroups;
    // Filter out groups that consist of draft files so they do not show up in the UI history list
    this.groupedEsignHistories = fullGroups.filter(g => g.items.every(item => item.status !== 'draft'));
  }

  openAddRecipientModal() {
    this.newRecipient = {
      name: '',
      email: '',
      countryCode: countries[0].dial_code,
      number: '',
      notificationMethod: 'email'
    };
    this.editingSignerIndex = null;
    this.editingAdhocSigner = null;
    this.esignModalDisplay = false;
    this.addRecipientModalDisplay = true;
  }

  // Edit a just-added (ad-hoc) signer in place. Reuses the same dialog as add/edit-saved,
  // pre-filled from the row's own object, which the save handler then updates (IOHB-1654).
  openEditAdhocSigner(row: any) {
    const signer = row.src;
    this.editingAdhocSigner = signer;
    this.editingSignerIndex = null;
    this.newRecipient = {
      name: signer.name || '',
      email: signer.email || '',
      countryCode: signer.countryCode || countries[0].dial_code,
      number: signer.number || '',
      notificationMethod: signer.notificationMethod || 'email',
    };
    this.esignModalDisplay = false;
    this.addRecipientModalDisplay = true;
  }

  onAddRecipientModalClose() {
    this.editingAdhocSigner = null;
    this.esignModalDisplay = true;
    this.cdr.detectChanges();
  }

  /** Company id the user lookup expects. A company admin MUST send their own companyId or the
   *  endpoint rejects the call outright; every other role sends null. Mirrors the User Management
   *  screen so the suggestions are exactly the set this user is already permitted to see. */
  private getSignerLookupCompanyId(): string | null {
    return this.currentUser?.is_company_admin ? this.currentUser?.companyId ?? null : null;
  }

  /** Maps a user record onto the suggestion shape the dropdown renders and autofills from. */
  private toSignerSuggestion(user: any) {
    const fullName = `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim();
    return {
      label: fullName || user?.email || "",
      email: user?.email ?? "",
      countryCode: user?.phone?.countryCode ?? "",
      number: (user?.phone?.number ?? "").replace(/\D/g, ""),
    };
  }

  /** Type-ahead for the Add Signer name field (IOHB-1779). Reuses the User Management lookup, so
   *  the list is limited to users this person can already see — agency/company scoping is enforced
   *  server side, meaning an agency-scoped admin never sees another agency's staff. */
  searchStaffSigners(event: { query: string }) {
    const query = event?.query?.trim() ?? "";
    if (query.length < DEFAULT_SEARCH_MIN_CHARACTER) {
      this.signerSuggestions = [];
      return;
    }
    const request = {
      search: query,
      // Only active staff can be picked as a signer — a terminated employee's contact
      // details must never be auto-filled onto a legal e-signature request.
      status: UserStatus.active,
      partOfAgency: [],
      globalAgency: "",
      role: [],
      pagination: { pageNumber: 0, pageSize: this.signerLookupPageSize },
      IOH: false,
      order: "",
      orderBy: "",
      companyId: this.getSignerLookupCompanyId(),
      usersFilter: [],
      provider: [],
    };
    const requestSeq = ++this.staffSignerSearchSeq;
    this.subscriptions.push(
      this.userService.getUsersWithSearch(request).subscribe({
        next: (res: any) => {
          // A later keystroke already issued a newer request — its response, whenever it
          // arrives, is the one that should win, not this now-stale one.
          if (requestSeq !== this.staffSignerSearchSeq) return;
          const users = res?.success ? res?.content?.data ?? [] : [];
          this.signerSuggestions = users.map((user) => this.toSignerSuggestion(user));
        },
        // A failed lookup must never block manual entry — just offer no suggestions.
        error: () => {
          if (requestSeq !== this.staffSignerSearchSeq) return;
          this.signerSuggestions = [];
        },
      }),
    );
  }

  /** Both when the signer has an email and a mobile on file, otherwise whichever single channel
   *  exists; falls back to email so the form keeps its existing default. */
  private resolveSignerDeliveryMethod(hasEmail: boolean, hasPhone: boolean): string {
    if (hasEmail && hasPhone) {
      return "both";
    }
    return hasPhone ? "phone" : "email";
  }

  /** Autofills the picked staff member's contact details. Anything not on file is left blank and
   *  stays editable, and the delivery method follows the channels they actually have. */
  onStaffSignerSelected(event: any) {
    // PrimeNG has emitted either the suggestion itself or a { value } wrapper across versions.
    // Detect the wrapper by key, not by truthiness — `{ value: null }` is a cleared selection and
    // must fall through to the guard below rather than being treated as the suggestion.
    const isWrapper = !!event && typeof event === "object" && "value" in event;
    const suggestion = isWrapper ? event.value : event;
    if (!suggestion) {
      return;
    }
    // ngModel holds the suggestion OBJECT immediately after a pick; put the plain name back so
    // every downstream consumer (validation, save, send) keeps seeing a string.
    this.newRecipient.name = suggestion.label ?? "";
    this.newRecipient.email = suggestion.email ?? "";

    const hasPhone = suggestion.number?.length === 10;
    this.newRecipient.number = hasPhone ? suggestion.number : "";
    if (hasPhone && countries.some((country) => country.dial_code === suggestion.countryCode)) {
      this.newRecipient.countryCode = suggestion.countryCode;
    }

    this.newRecipient.notificationMethod = this.resolveSignerDeliveryMethod(!!suggestion.email, hasPhone);
    this.signerSuggestions = [];
  }

  /** Guarantees newRecipient.name is a string. p-autoComplete leaves the bound model as the
   *  suggestion object if a pick is never normalised, which would fail name validation. */
  private normalizeRecipientName() {
    const name: any = this.newRecipient?.name;
    if (name && typeof name === "object") {
      this.newRecipient.name = name.label ?? "";
    }
  }

  /** Validates the add/edit-signer form and returns the first error message, or null when valid.
   *  Extracted from addAdditionalRecipient to keep that method within the complexity budget. */
  private validateNewRecipient(): string | null {
    if (!this.newRecipient.name?.trim()) {
      return "Recipient name is required";
    }
    const method = this.newRecipient.notificationMethod;
    const needsEmail = method === 'email' || method === 'both';
    const needsPhone = method === 'phone' || method === 'both';
    const email = this.newRecipient.email?.trim();

    if (needsEmail && !email) {
      return "Recipient email is required";
    }
    // Signer email must be a valid format when email delivery is selected (IOHB-1703). Same
    // pattern the patient email field already uses so signer and patient validation stay in step.
    const signerEmailRe = /^[^\s@]+@[^\s@.]+(?:\.[^\s@.]+)*\.[^\s@.]+$/;
    if (needsEmail && email && !signerEmailRe.test(email)) {
      return "Please enter a valid email address";
    }
    if (needsPhone && !this.newRecipient.number?.trim()) {
      return "Recipient phone number is required";
    }
    if (this.newRecipient.number && this.newRecipient.number.replace(/\D/g, '').length !== 10) {
      return "Invalid phone number format";
    }
    return null;
  }

  addAdditionalRecipient() {
    this.normalizeRecipientName();
    const validationError = this.validateNewRecipient();
    if (validationError) {
      this.messageHandlerService.generateToastMessage("error", "Error", validationError);
      return;
    }

    if (this.editingSignerIndex !== null) {
      const index = this.editingSignerIndex;
      const originalSigner = this.savedSigners[index];

      let phoneToSave = '';
      if (this.newRecipient.number) {
        phoneToSave = this.newRecipient.countryCode + this.newRecipient.number.replace(/\D/g, '');
      }

      const updatedSigner = {
        ...originalSigner,
        name: this.newRecipient.name,
        email: this.newRecipient.email || undefined,
        phone: phoneToSave || undefined,
        notificationMethod: this.newRecipient.notificationMethod,
        createdAt: new Date(),
      };

      this.savedSigners[index] = updatedSigner;

      // Update the matching recipient if this saved signer is currently on the send. Match
      // on the signer's ORIGINAL identity (pre-edit), country-code aware (IOHB-1657).
      this.additionalRecipients = this.additionalRecipients.map(rec => {
        if (this.sameSigner(rec, originalSigner)) {
          return {
            name: updatedSigner.name,
            email: updatedSigner.email || '',
            number: this.newRecipient.number,
            countryCode: this.newRecipient.countryCode,
            notificationMethod: updatedSigner.notificationMethod,
            isPatient: false
          };
        }
        return rec;
      });

      this.editingSignerIndex = null;
      this.savedSigners = [...this.savedSigners];
      this.addRecipientModalDisplay = false;
      this.scheduleAutoSaveDraft();
      return;
    }

    if (this.editingAdhocSigner !== null) {
      const original = this.editingAdhocSigner;
      const updated = {
        name: this.newRecipient.name,
        email: this.newRecipient.email || '',
        number: this.newRecipient.number || '',
        countryCode: this.newRecipient.countryCode,
        notificationMethod: this.newRecipient.notificationMethod,
        isPatient: false,
      };
      // Replace the exact object the user opened for edit, whether it's currently on the
      // send (additionalRecipients) or parked as deselected (unsentAdhocSigners).
      this.additionalRecipients = this.additionalRecipients.map((r: any) => (r === original ? updated : r));
      this.unsentAdhocSigners = this.unsentAdhocSigners.map((r: any) => (r === original ? updated : r));
      this.editingAdhocSigner = null;
      this.addRecipientModalDisplay = false;
      this.scheduleAutoSaveDraft();
      return;
    }

    // Guard: never add the patient as an extra signer (they always sign), and block a duplicate
    // contact (same email or phone) whether it's on the send, saved, or parked as deselected.
    if (this.isPatientContact(this.newRecipient)) {
      this.messageHandlerService.generateToastMessage("error", "Error", "This is the patient — they already sign and can’t be added as an extra signer.");
      return;
    }
    if (this.isDuplicateSignerContact(this.newRecipient)) {
      this.messageHandlerService.generateToastMessage("error", "Error", "A signer with the same email or phone number is already added.");
      return;
    }

    this.additionalRecipients.push({ ...this.newRecipient });
    this.addRecipientModalDisplay = false;
    this.scheduleAutoSaveDraft();
  }

  removeAdditionalRecipient(index: number) {
    this.additionalRecipients.splice(index, 1);
    this.scheduleAutoSaveDraft();
  }

  hasValidPhone(phone: any): boolean {
    if (!phone) return false;
    const cleanPhone = phone.replace(/\D/g, '');
    return cleanPhone.length > 4;
  }

  isSignerChecked(signer: any): boolean {
    // A saved signer is "on this send" when a matching recipient is already in
    // additionalRecipients. Matching must be country-code aware (IOHB-1657), so reuse
    // sameSigner instead of a divergent inline comparison.
    return this.additionalRecipients.some(rec => this.sameSigner(rec, signer));
  }

  toggleSavedSigner(signer: any, event: any) {
    const checked = event.checked;

    if (checked) {
      if (!this.isSignerChecked(signer)) {
        let signerPhone = signer.phone || signer.number || '';
        let countryCode = countries[0].dial_code;
        let phoneNum = signerPhone;
        for (const c of countries) {
          if (signerPhone.startsWith(c.dial_code)) {
            countryCode = c.dial_code;
            phoneNum = signerPhone.substring(c.dial_code.length).trim();
            break;
          }
        }

        if (!this.isCompletePhoneNumber(phoneNum)) {
          phoneNum = '';
        }

        this.additionalRecipients.push({
          name: signer.name,
          email: signer.email || '',
          number: phoneNum || '',
          countryCode: countryCode,
          notificationMethod: signer.notificationMethod || 'email',
          isPatient: false
        });
        this.additionalRecipients = [...this.additionalRecipients];
      }
    } else {
      this.additionalRecipients = this.additionalRecipients.filter(rec => !this.sameSigner(rec, signer));
      this.invalidateSignerFieldMapping();
    }
    this.scheduleAutoSaveDraft();
  }

  // --- Unified "Signers" list (IOHB-1632 UX): one grouped list instead of the
  // separate Saved / Additional sections. The patient is pinned separately; this
  // returns every OTHER signer — the saved roster plus any just-added ad-hoc
  // signers not yet in the roster — each flagged with whether it's on this send.
  // Digits-only phone INCLUDING the country code, from EITHER storage shape: saved signers
  // keep the whole number in `phone` (country code + number, e.g. "+12225551234"); ad-hoc
  // recipients keep `countryCode` and `number` separately. Canonicalising both is what lets
  // the same person compare equal regardless of which shape they're in (IOHB-1657).
  private phoneDigits(obj: any): string {
    if (obj?.phone) return String(obj.phone).replace(/\D/g, '');
    const cc = String(obj?.countryCode || '').replace(/\D/g, '');
    const num = String(obj?.number || '').replace(/\D/g, '');
    return num ? cc + num : '';
  }

  private samePhone(a: any, b: any): boolean {
    const pa = this.phoneDigits(a);
    const pb = this.phoneDigits(b);
    if (!pa || !pb) return false;
    // Equal outright, or the same 10-digit national number with/without a country code — so
    // a saved "+1 222-555-1234" matches an ad-hoc {number:"222-555-1234", countryCode:"+1"}.
    return pa === pb || (pa.length >= 10 && pb.length >= 10 && pa.slice(-10) === pb.slice(-10));
  }

  private sameSigner(a: any, b: any): boolean {
    const aName = a?.name?.trim().toLowerCase();
    const bName = b?.name?.trim().toLowerCase();
    const aEmail = a?.email?.trim().toLowerCase() || '';
    const bEmail = b?.email?.trim().toLowerCase() || '';
    const emailMatch = !!aEmail && aEmail === bEmail;
    return aName === bName && (emailMatch || this.samePhone(a, b));
  }

  /** Contact-level match: same email OR same phone, independent of name — used to block duplicate
   *  signers and to stop the patient being re-added as an extra signer. */
  private sameContact(a: any, b: any): boolean {
    const aEmail = a?.email?.trim().toLowerCase() || '';
    const bEmail = b?.email?.trim().toLowerCase() || '';
    return (!!aEmail && aEmail === bEmail) || this.samePhone(a, b);
  }

  /** True when the candidate matches the patient's own email/phone. The patient always signs, so
   *  they must never be added as an additional signer. */
  isPatientContact(candidate: any): boolean {
    const eSoc = this.selectedEsocRecord?.patientEsocData;
    const patient = eSoc?.patient;
    if (!patient) return false;
    const email = (eSoc?.eSocEmailPhonePreference?.email?.email || patient?.contactInfo?.email || '').trim();
    const phone = (patient?.contactInfo?.phone || '').toString().trim();
    if (!email && !phone) return false;
    return this.sameContact(candidate, { email, phone });
  }

  /** True when the candidate duplicates a signer already added — on the send, in the saved roster,
   *  or parked as deselected. */
  isDuplicateSignerContact(candidate: any): boolean {
    return [...(this.savedSigners || []), ...(this.additionalRecipients || []), ...(this.unsentAdhocSigners || [])]
      .some(s => this.sameContact(candidate, s));
  }

  private _signerRowsKey = '';
  private _signerRowsReceiving: any[] = [];
  private _signerRowsNotSending: any[] = [];

  // Ad-hoc signers added via "Add Signer" that the user then UNCHECKED. Unlike a saved
  // signer, an ad-hoc signer only ever lived in additionalRecipients, so unchecking it
  // used to delete it outright (IOHB-1653). We park it here instead — kept visible under
  // "not on this send", consistent with unchecking a saved signer — until it is re-checked
  // (moved back onto the send) or removed with the trash button.
  unsentAdhocSigners: any[] = [];

  // Memoized so the getters return STABLE array references across change-detection
  // cycles (a fresh array each CD would make the *ngFor rebuild every tick). Recomputes
  // only when the saved roster or this-send recipients actually change.
  private computeSignerRows(): void {
    const saved = this.savedSigners || [];
    const extra = this.additionalRecipients || [];
    const unsent = this.unsentAdhocSigners || [];
    const key =
      saved.map((s: any) => `${s.name}|${s.email}|${s.phone || ''}|${s.notificationMethod}`).join('~') +
      '#' +
      extra.map((r: any) => `${r.name}|${r.email}|${r.number || ''}|${r.notificationMethod}`).join('~') +
      '#' +
      unsent.map((r: any) => `${r.name}|${r.email}|${r.number || ''}|${r.notificationMethod}`).join('~');
    if (key === this._signerRowsKey) return;

    const rows: any[] = [];
    saved.forEach((s: any, i: number) => {
      const contact = this.signerRowContact(s.notificationMethod, s.email, s.phone);
      rows.push({
        src: s, name: s.name, email: contact.email, phoneDisplay: contact.phoneDisplay,
        method: s.notificationMethod || 'email', isSaved: true, savedIndex: i, isNew: false,
        checked: this.isSignerChecked(s),
      });
    });
    extra.forEach((r: any) => {
      if (!saved.some((s: any) => this.sameSigner(s, r))) {
        const contact = this.signerRowContact(r.notificationMethod, r.email, this.adhocPhone(r));
        rows.push({
          src: r, name: r.name, email: contact.email, phoneDisplay: contact.phoneDisplay,
          method: r.notificationMethod || 'email', isSaved: false, savedIndex: -1, isNew: true, checked: true,
        });
      }
    });
    // Added-then-deselected ad-hoc signers: shown UNCHECKED under "not on this send" so
    // they survive an uncheck instead of vanishing. Skip any that are back on the send or
    // already in the saved roster (defensive against duplicate rows).
    unsent.forEach((r: any) => {
      const onSend = extra.some((e: any) => this.sameSigner(e, r));
      const inRoster = saved.some((s: any) => this.sameSigner(s, r));
      if (!onSend && !inRoster) {
        const contact = this.signerRowContact(r.notificationMethod, r.email, this.adhocPhone(r));
        rows.push({
          src: r, name: r.name, email: contact.email, phoneDisplay: contact.phoneDisplay,
          method: r.notificationMethod || 'email', isSaved: false, savedIndex: -1, isNew: true, checked: false,
        });
      }
    });

    this._signerRowsKey = key;
    this._signerRowsReceiving = rows.filter((r) => r.checked);
    this._signerRowsNotSending = rows.filter((r) => !r.checked);
  }

  /** Phone string for an ad-hoc recipient ({ countryCode, number }); empty when there is no
   *  number, so a signer with only the default country code never shows a bare "+1". */
  private adhocPhone(r: any): string {
    return r?.number ? ((r.countryCode ? r.countryCode + ' ' : '') + r.number).trim() : '';
  }

  /** A signer-row's contact line follows the chosen delivery method: 'email' shows only the
   *  email, 'phone' shows only the phone, 'both' shows both. Anything falsy stays hidden. */
  private signerRowContact(method: string, email: string, phone: string): { email: string; phoneDisplay: string } {
    const m = method || 'email';
    return {
      email: (m === 'email' || m === 'both') ? (email || '') : '',
      phoneDisplay: (m === 'phone' || m === 'both') ? (phone || '') : '',
    };
  }

  get esignReceivingSigners(): any[] { this.computeSignerRows(); return this._signerRowsReceiving; }
  get esignSavedNotSending(): any[] { this.computeSignerRows(); return this._signerRowsNotSending; }
  /** "Receiving a link" counts the patient only when they sign this document (IOHB-1865). */
  get esignReceivingCount(): number { this.computeSignerRows(); return (this.esignPatientSigns ? 1 : 0) + this._signerRowsReceiving.length; }

  /** Whether the patient gets a signing link on this send (IOHB-1865). Once the document is prepared this follows the
   *  send itself, which only links signers who have a signature spot; before that, how the document was set up. */
  get esignPatientSigns(): boolean {
    const mapped = this.getMappedSignerIdsForSelectedTemplates();
    if (mapped.size > 0) return mapped.has('patient');
    const template: any = this.selectedTemplates?.[0];
    if (!template) return true;
    const cached = this.templatePatientSigRequiredCache[template.fileName];
    if (cached !== undefined) return cached;
    return template.isPatientSignatureRequired !== undefined ? !!template.isPatientSignatureRequired : true;
  }

  onSignerRowToggle(row: any, event: any): void {
    // Saved signers persist in the roster, so toggling just adds/removes them from the
    // send (toggleSavedSigner keeps the roster copy). Ad-hoc signers have no roster copy,
    // so unchecking must KEEP them (park in unsentAdhocSigners) rather than delete — IOHB-1653.
    if (row.isSaved) {
      this.toggleSavedSigner(row.src, event);
    } else {
      this.toggleAdhocSigner(row.src, event.checked);
    }
  }

  private toggleAdhocSigner(signer: any, checked: boolean): void {
    if (checked) {
      // Re-include on the send: move back from the deselected list to additionalRecipients.
      this.unsentAdhocSigners = this.unsentAdhocSigners.filter((r: any) => !this.sameSigner(r, signer));
      if (!this.additionalRecipients.some((r: any) => this.sameSigner(r, signer))) {
        this.additionalRecipients = [...this.additionalRecipients, signer];
      }
    } else {
      // Deselect but KEEP: move off the send into the deselected list (do NOT delete).
      this.additionalRecipients = this.additionalRecipients.filter((r: any) => !this.sameSigner(r, signer));
      if (!this.unsentAdhocSigners.some((r: any) => this.sameSigner(r, signer))) {
        this.unsentAdhocSigners = [...this.unsentAdhocSigners, signer];
      }
      this.invalidateSignerFieldMapping();
    }
    this.scheduleAutoSaveDraft();
  }

  removeUnsavedSigner(row: any): void {
    this.additionalRecipients = this.additionalRecipients.filter((r: any) => !this.sameSigner(r, row.src));
    this.unsentAdhocSigners = this.unsentAdhocSigners.filter((r: any) => !this.sameSigner(r, row.src));
    this.invalidateSignerFieldMapping();
    this.scheduleAutoSaveDraft();
  }

  // IOHB-1655/1656 hardening: the signer -> signature-field mapping is POSITIONAL (keyed by the
  // signer's index in the list). Removing or deselecting a signer shifts the remaining signers'
  // positions, which would silently re-point their field mappings to the wrong signer. Discard
  // the prepared mapping when the signer set shrinks so the document must be re-prepared — the
  // send is then blocked by IOHB-1656 until it is re-mapped correctly. Typed form values
  // (filledCustomFile) are preserved; only the field-to-signer assignment is cleared.
  private invalidateSignerFieldMapping(): void {
    if (Object.keys(this.templateSignerTagsCache).length > 0) {
      this.templateSignerTagsCache = {};
    }
  }

  esignMethodLabel(method: string): string {
    if (method === 'both') return 'Email + SMS';
    if (method === 'phone') return 'SMS';
    return 'Email';
  }

  esignPatientMethodLabel(): string {
    const e = this.esignSubmissionForm?.email?.preferred;
    const p = this.esignSubmissionForm?.phoneNumber?.preferred;
    if (e && p) return 'Email + SMS';
    if (e) return 'Email';
    if (p) return 'SMS';
    return 'No method selected';
  }

  /** Patient chip: show the phone only when the patient's method includes SMS AND the number is a
   *  complete 10-digit number. Mirrors signerRowContact()/isCompletePhoneNumber() so an Email-only
   *  patient, or an incomplete/extension value (e.g. "11"), shows no phone. Display-only. */
  get esignPatientPhoneDisplay(): string {
    const p = this.esignPhoneList?.[0];
    const wantsPhone = !!this.esignSubmissionForm?.phoneNumber?.preferred;
    if (!p || !wantsPhone || !this.isCompletePhoneNumber(p.number)) return '';
    return `${p.countryCode} ${p.number.trim()}`;
  }

  esignSignerInitials(name: string): string {
    if (!name) return '?';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const initials = (parts[0]?.[0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '');
    return initials.toUpperCase() || '?';
  }

  removeSavedSigner(index: number) {
    this.confirmationService.confirm({
      message: "Are you sure you want to delete this saved signer? This will take effect when you send the E-Sign request.",
      header: "Delete Saved Signer",
      icon: "pi pi-trash",
      acceptButtonStyleClass: "btn-delete",
      accept: () => {
        const signer = this.savedSigners[index];
        // Country-code aware match so a phone-only signer's recipient copy is also removed
        // (IOHB-1657 — this site had the divergent inline compare).
        this.additionalRecipients = this.additionalRecipients.filter(rec => !this.sameSigner(rec, signer));
        this.savedSigners.splice(index, 1);
        this.savedSigners = [...this.savedSigners];
        this.invalidateSignerFieldMapping();
        this.scheduleAutoSaveDraft();
      }
    });
  }

  openEditSavedSignerModal(index: number) {
    const signer = this.savedSigners[index];
    this.editingSignerIndex = index;
    this.editingAdhocSigner = null;

    let signerPhone = signer.phone || signer.number || '';
    let countryCode = countries[0].dial_code;
    let phoneNum = signerPhone;
    for (const c of countries) {
      if (signerPhone.startsWith(c.dial_code)) {
        countryCode = c.dial_code;
        phoneNum = signerPhone.substring(c.dial_code.length).trim();
        break;
      }
    }

    this.newRecipient = {
      name: signer.name,
      email: signer.email || '',
      countryCode: countryCode,
      number: phoneNum,
      notificationMethod: signer.notificationMethod || 'email'
    };

    this.esignModalDisplay = false;
    this.addRecipientModalDisplay = true;
  }

  /** One document per request: selecting a template replaces the selection so only a
   *  single document is ever prepared and sent at a time (keeps selectedTemplates an
   *  array of length 1 so all downstream logic is unchanged). */
  selectSingleTemplate(template: any) {
    this.selectedTemplates = [template];
  }

  isTemplateSelected(template: any): boolean {
    return !!this.selectedTemplates?.some((t: any) => t.fileName === template.fileName);
  }

  /** Option 1 auto-save: after a signer or document change, silently persist the draft
   *  (debounced ~1s) so the user never has to remember to press Save. Only runs when a
   *  document is selected — a draft needs a document to attach to. Non-destructive:
   *  saveOnly drafts never touch pending/signed records. The explicit Save button stays
   *  as a fallback. */
  scheduleAutoSaveDraft() {
    if (this.autoSaveTimer) {
      clearTimeout(this.autoSaveTimer);
    }
    this.autoSaveTimer = setTimeout(() => {
      this.autoSaveTimer = null;
      if (this.sendingEsign || this.autoSaving) return;
      if (!this.selectedEsocRecord) return;
      if (!this.selectedTemplates || this.selectedTemplates.length === 0) return;
      this.sendEsignRequest(true, true); // saveOnly + silent
    }, 1000);
  }

  /**
   * True when a "Save & Send" is fully ready to dispatch. Otherwise shows one error
   * notification listing every problem and returns false. This replicates exactly the
   * conditions that used to disable the Save & Send button, moved to click-time so the
   * user is told WHY instead of facing a silently-greyed button.
   */
  isEsignReadyToSend(): boolean {
    this.isEsignPhoneNumberValid();
    this.isEsignDobValid();

    // IOHB-1779 follow-up: identify the patient by their stable signer id, never by display
    // name — a POA/guardian entered with the same name as the patient would otherwise be
    // conflated with them, silently changing which validations run.
    const mappedSignerIds = this.getMappedSignerIdsForSelectedTemplates();
    const isPatientRecipient = mappedSignerIds.size === 0 || mappedSignerIds.has('patient');

    const emailSelected = !!this.esignSubmissionForm?.email?.preferred;
    const phoneSelected = !!this.esignSubmissionForm?.phoneNumber?.preferred;
    const email0 = this.esignEmailList?.[0]?.email?.trim();
    const emailRe = /^[^\s@]+@[^\s@\.]+(?:\.[^\s@\.]+)*\.[^\s@\.]+$/;
    const errors: string[] = [];

    // Delivery method and consent validations only apply to patient if patient is an actual recipient
    if (isPatientRecipient) {
      if (!emailSelected && !phoneSelected) {
        errors.push("select a delivery method (Send via Email and/or Send via Phone)");
      }
      if (emailSelected && !email0) {
        errors.push("enter an email address or untick Send via Email");
      }
      if ((this.esignEmailList || []).some((e) => e.email?.trim() && !emailRe.test(e.email.trim()))) {
        errors.push("enter a valid email address");
      }
      if (!this.isValidEsignPhone) {
        errors.push("enter a valid 10-digit phone number for the selected phone delivery");
      }
      if (!this.esignSubmissionForm?.isChecked) {
        errors.push("confirm consent to receive the document via email or SMS");
      }
    }

    if (!this.esignSubmissionForm?.dob) {
      errors.push("enter the patient date of birth");
    } else if (this.showEsignDobInvalidError) {
      errors.push("the date of birth cannot be in the future");
    }

    if (errors.length > 0) {
      this.messageHandlerService.generateToastMessage("error", "Cannot send yet", "Please " + errors.join("; ") + ".");
      return false;
    }
    return true;
  }

  sendEsignRequest(saveOnly = false, silent = false) {
    // A user-initiated Save / Save & Send supersedes any queued silent auto-save. Cancel the
    // pending auto-save timer so the two requests don't race to write the same patient document
    // (which previously surfaced as a Mongoose VersionError 500 on esignSigners).
    if (!silent && this.autoSaveTimer) {
      clearTimeout(this.autoSaveTimer);
      this.autoSaveTimer = null;
    }
    if (!this.selectedTemplates || this.selectedTemplates.length === 0) {
      if (!silent) {
        this.messageHandlerService.generateToastMessage("error", "Error", "Please select at least one signing template");
      }
      return;
    }

    // "Save" keeps the draft as-is (no validation — nothing is sent). Only "Save & Send"
    // is validated, on click, surfacing every problem as an error notification instead of
    // silently disabling the button. This mirrors exactly what previously gated the button.
    if (!saveOnly && !this.isEsignReadyToSend()) {
      return;
    }

    // IOHB-1656: refuse to SEND a document that has no signature-field mapping at all. With
    // nothing mapped there is nothing to sign, and the send would (a) email every selected
    // party and (b) show every signature field on the document to each of them — a real
    // signing loophole. The user must prepare the document (open it and assign a signature
    // field to a signer) first. Saving a draft (saveOnly) is still allowed while in progress.
    if (!saveOnly && this.getMappedSignerIdsForSelectedTemplates().size === 0) {
      this.messageHandlerService.generateToastMessage(
        "error",
        "Cannot send yet",
        "Please prepare the document for signing — open it and map a signature field to a signer before sending."
      );
      return;
    }

    const validEmails = this.esignEmailList.filter((e) => e.email?.trim());
    let esocRequest: any = {
      submittedOn: new Date(),
      status: eSockStatus.APPROVED,
      consent: this.esignSubmissionForm?.isChecked,
      email: {
        email: validEmails[0]?.email?.trim() || "",
        primaryEmail: validEmails[1]?.email?.trim() || "",
        secondaryEmail: validEmails[2]?.email?.trim() || "",
        preferred: this.esignSubmissionForm.email.preferred,
        sent: false,
      },
      phone: {
        countryCode: this.esignPhoneList[0]?.countryCode || countries[0].dial_code,
        number: this.isCompletePhoneNumber(this.esignPhoneList[0]?.number) ? this.esignPhoneList[0].number.trim() : "",
        primaryCountryCode: this.esignPhoneList[1]?.countryCode || countries[0].dial_code,
        primaryNumber: this.isCompletePhoneNumber(this.esignPhoneList[1]?.number) ? this.esignPhoneList[1].number.trim() : "",
        secondaryCountryCode: this.esignPhoneList[2]?.countryCode || countries[0].dial_code,
        secondaryNumber: this.isCompletePhoneNumber(this.esignPhoneList[2]?.number) ? this.esignPhoneList[2].number.trim() : "",
        preferred: this.esignSubmissionForm.phoneNumber.preferred,
        sent: false,
      },
    };

    // A silent auto-save must NOT disable the manual Save / Save & Send / Close buttons,
    // so it uses its own in-flight flag instead of sendingEsign.
    if (silent) {
      this.autoSaving = true;
      this.autoSaveStatus = 'saving';
    } else {
      this.sendingEsign = true;
      this.progressBarService.setProgressBarVisibility(true);
    }

    this.patientService.updatePatientSubmission({
      patientId: this.selectedEsocRecord?.patientEsocData?.patientId || this.selectedEsocRecord?.patientId,
      eSoc: esocRequest,
      dob: this.formatEsignDate(),
    }).subscribe({
      next: (res) => {
        if (res?.success) {
          const mappedTemplates = this.selectedTemplates.map(t => {
            const tags = this.templateSignerTagsCache[t.fileName] || {};
            const signerTagsPayload: Record<string, any> = {};

            const signersList = this.getSignersForTagging();
            signersList.forEach(s => {
              const tagConfig = tags[s.id];
              if (tagConfig) {
                // The wire format keys signerTags by display name, not signer id, so two
                // signers sharing a name (e.g. a POA with the same name as the patient) would
                // otherwise silently clobber each other's field mapping here. Merge onto any
                // existing entry for that name instead of overwriting, so neither signer's
                // fields are silently dropped — an inherent limitation of a name-keyed payload
                // when two distinct signers truly share a name (IOHB-1779 follow-up).
                const existing = signerTagsPayload[s.name] || {};
                signerTagsPayload[s.name] = {
                  signatureField: tagConfig.signatureField || existing.signatureField || undefined,
                  signatureField2: tagConfig.signatureField2 || existing.signatureField2 || undefined,
                  signatureField3: tagConfig.signatureField3 || existing.signatureField3 || undefined,
                  signatureField4: tagConfig.signatureField4 || existing.signatureField4 || undefined,
                  signatureField5: tagConfig.signatureField5 || existing.signatureField5 || undefined,
                  signatureField6: tagConfig.signatureField6 || existing.signatureField6 || undefined,
                  signatureField7: tagConfig.signatureField7 || existing.signatureField7 || undefined,
                  signatureField8: tagConfig.signatureField8 || existing.signatureField8 || undefined,
                  signatureField9: tagConfig.signatureField9 || existing.signatureField9 || undefined,
                  signatureField10: tagConfig.signatureField10 || existing.signatureField10 || undefined,
                  dateField: tagConfig.dateField || existing.dateField || undefined,
                  dateField2: tagConfig.dateField2 || existing.dateField2 || undefined,
                  dateField3: tagConfig.dateField3 || existing.dateField3 || undefined,
                  dateField4: tagConfig.dateField4 || existing.dateField4 || undefined,
                  dateField5: tagConfig.dateField5 || existing.dateField5 || undefined,
                  dateField6: tagConfig.dateField6 || existing.dateField6 || undefined,
                  dateField7: tagConfig.dateField7 || existing.dateField7 || undefined,
                  dateField8: tagConfig.dateField8 || existing.dateField8 || undefined,
                  dateField9: tagConfig.dateField9 || existing.dateField9 || undefined,
                  dateField10: tagConfig.dateField10 || existing.dateField10 || undefined,
                  signatureFieldOptional: !!tagConfig.signatureFieldOptional || !!existing.signatureFieldOptional,
                  signatureField2Optional: !!tagConfig.signatureField2Optional || !!existing.signatureField2Optional,
                  signatureField3Optional: !!tagConfig.signatureField3Optional || !!existing.signatureField3Optional,
                  signatureField4Optional: !!tagConfig.signatureField4Optional || !!existing.signatureField4Optional,
                  signatureField5Optional: !!tagConfig.signatureField5Optional || !!existing.signatureField5Optional,
                  signatureField6Optional: !!tagConfig.signatureField6Optional || !!existing.signatureField6Optional,
                  signatureField7Optional: !!tagConfig.signatureField7Optional || !!existing.signatureField7Optional,
                  signatureField8Optional: !!tagConfig.signatureField8Optional || !!existing.signatureField8Optional,
                  signatureField9Optional: !!tagConfig.signatureField9Optional || !!existing.signatureField9Optional,
                  signatureField10Optional: !!tagConfig.signatureField10Optional || !!existing.signatureField10Optional,
                  ...this.fillFieldsPayload(existing.fillFields, tagConfig.fillFields)
                };
              }
            });

            if (t.filledCustomFile) {
              return {
                fileOriginalName: t.filledCustomFile.fileOriginalName,
                fileName: t.filledCustomFile.fileName,
                fileLocation: t.filledCustomFile.fileLocation,
                signerTags: signerTagsPayload
              };
            }
            return {
              fileOriginalName: t.fileOriginalName,
              fileName: t.fileName,
              fileLocation: t.fileLocation,
              signerTags: signerTagsPayload
            };
          });

          const patientName = this.selectedEsocRecord.patientName || 'Patient';
          const patientEmail = validEmails.map(e => e.email.trim()).join(', ');
          const patientPhone = this.esignPhoneList.filter(p => this.isCompletePhoneNumber(p.number)).map(p => p.countryCode + p.number.trim().replace(/\D/g, '')).join(', ');

          // Each entry carries the signer id it was tagged under ('patient' / 'recipient-<idx>',
          // matching getSignersForTagging()), so the mapped-signer filter below can match on
          // identity instead of display name. The payload shape sent to the API is unchanged.
          const recipientEntries: { signerId: string; recipient: any }[] = [
            {
              signerId: 'patient',
              recipient: {
                name: patientName,
                email: patientEmail,
                phone: patientPhone,
                notificationMethod: (this.esignSubmissionForm.email.preferred && this.esignSubmissionForm.phoneNumber.preferred)
                  ? 'both'
                  : this.esignSubmissionForm.email.preferred
                    ? 'email'
                    : 'phone',
                isPatient: true
              }
            },
            ...this.additionalRecipients.map((r, idx) => ({
              signerId: `recipient-${idx}`,
              recipient: {
                name: r.name,
                email: (r.notificationMethod === 'email' || r.notificationMethod === 'both') ? r.email : undefined,
                phone: (r.notificationMethod === 'phone' || r.notificationMethod === 'both') && this.isCompletePhoneNumber(r.number) ? (r.countryCode + r.number.replace(/\D/g, '')) : undefined,
                notificationMethod: r.notificationMethod,
                isPatient: false
              }
            }))
          ];

          // IOHB-1655: the people who receive a signing link must be the entities actually
          // MAPPED to a signature field in the document — not merely those ticked in the Signers
          // list. An "outside" signer who was selected but never assigned a field (e.g. added
          // after the document was prefilled/tagged) must NOT be emailed. Applied on a real send
          // only; Save (draft) keeps every recipient so the draft config isn't lost. The all-
          // unmapped case is already refused above (IOHB-1656), so a real send always has >=1.
          const mappedSignerIdsForSend = this.getMappedSignerIdsForSelectedTemplates();
          const finalRecipients = (!saveOnly
            ? recipientEntries.filter(e => mappedSignerIdsForSend.has(e.signerId))
            : recipientEntries).map(e => e.recipient);

          const payload = {
            patientID: this.selectedEsocRecord.patientEsocData?._id || this.selectedEsocRecord._id,
            templates: mappedTemplates,
            customMessage: this.customMessage,
            recipients: finalRecipients,
            esignSigners: this.savedSigners,
            saveOnly: saveOnly
          };

          this.esocService.sendEsign(payload).subscribe({
            next: (sendRes) => {
              if (silent) {
                this.autoSaving = false;
                this.autoSaveStatus = sendRes?.success ? 'saved' : 'idle';
              } else {
                this.sendingEsign = false;
                this.progressBarService.setProgressBarVisibility(false);
                if (sendRes?.success) {
                  this.messageHandlerService.generateToastMessage("success", "Success", saveOnly ? "E-Sign config saved successfully" : "E-Sign request sent successfully");
                  this.geteSocPatientSubmissions();
                  this.esignModalDisplay = false;
                } else {
                  this.messageHandlerService.generateToastMessage("error", "Error", sendRes?.message || "Failed to process E-Sign request");
                }
              }
            },
            error: (err) => {
              if (silent) {
                this.autoSaving = false;
                this.autoSaveStatus = 'idle';
              } else {
                this.sendingEsign = false;
                this.progressBarService.setProgressBarVisibility(false);
                this.messageHandlerService.generateToastMessage("error", "Error", err?.message || "Failed to process E-Sign request");
              }
            }
          });
        } else {
          if (silent) {
            this.autoSaving = false;
            this.autoSaveStatus = 'idle';
          } else {
            this.sendingEsign = false;
            this.progressBarService.setProgressBarVisibility(false);
            this.messageHandlerService.generateToastMessage("error", "Error", "Failed to update delivery preferences");
          }
        }
      },
      error: (err) => {
        if (silent) {
          this.autoSaving = false;
          this.autoSaveStatus = 'idle';
        } else {
          this.sendingEsign = false;
          this.progressBarService.setProgressBarVisibility(false);
          this.messageHandlerService.generateToastMessage("error", "Error", "Failed to update delivery preferences");
        }
      }
    });
  }

  resendEsignLink(historyItem: any) {
    if (!historyItem) return;
    this.progressBarService.setProgressBarVisibility(true);

    const signerName = historyItem.recipientName || this.selectedEsocRecord.patientName || (historyItem.isPatient ? 'Patient' : 'Signer');
    const signerTag: any = {};
    for (let i = 1; i <= 10; i++) {
      const suffix = i === 1 ? '' : String(i);
      const sigField = historyItem[`signatureFieldName${suffix}`];
      const dateField = historyItem[`dateFieldName${suffix}`];
      const sigOpt = historyItem[`signatureFieldName${suffix}Optional`];
      if (sigField) signerTag[`signatureField${suffix}`] = sigField;
      if (dateField) signerTag[`dateField${suffix}`] = dateField;
      if (sigOpt) signerTag[`signatureField${suffix}Optional`] = sigOpt;
    }
    const fillFields = this.copyFillFields(historyItem.fillFields);
    if (fillFields.length > 0) signerTag.fillFields = fillFields;

    const templateObj: any = {
      fileOriginalName: historyItem.fileOriginalName,
      fileName: historyItem.fileName,
      fileLocation: historyItem.fileLocation,
    };
    if (Object.keys(signerTag).length > 0) {
      templateObj.signerTags = { [signerName]: signerTag };
    }

    const payload = {
      patientID: this.selectedEsocRecord.patientEsocData?._id || this.selectedEsocRecord._id,
      templates: [templateObj],
      customMessage: '',
      recipients: [{
        name: signerName,
        email: historyItem.patientEmail,
        phone: historyItem.recipientPhone,
        notificationMethod: historyItem.notificationMethod || 'email',
        isPatient: historyItem.isPatient || false
      }]
    };

    this.esocService.sendEsign(payload).subscribe({
      next: (res) => {
        this.progressBarService.setProgressBarVisibility(false);
        if (res?.success) {
          this.messageHandlerService.generateToastMessage("success", "Success", "E-Sign link resent successfully");
          this.geteSocPatientSubmissions();
          this.esignModalDisplay = false;
        } else {
          this.messageHandlerService.generateToastMessage("error", "Error", res?.message || "Failed to resend E-Sign request");
        }
      },
      error: (err) => {
        this.progressBarService.setProgressBarVisibility(false);
        this.messageHandlerService.generateToastMessage("error", "Error", err?.message || "Failed to resend E-Sign request");
      }
    });
  }

  extractKey(fileLocation: string): string {
    if (!fileLocation) return '';
    const companyMrnRegex = /\/?([a-f0-9]{24}|unknown)\/([a-f0-9]{32})\//i;
    const companyMrnMatch = fileLocation.match(companyMrnRegex);
    if (companyMrnMatch) {
      const index = fileLocation.indexOf(companyMrnMatch[1]);
      let key = fileLocation.substring(index);
      const qIndex = key.indexOf('?');
      if (qIndex > -1) {
        key = key.substring(0, qIndex);
      }
      return key;
    }
    const md5Regex = /([a-f0-9]{32})\//i;
    const match = fileLocation.match(md5Regex);
    if (match) {
      const index = fileLocation.indexOf(match[0]);
      let key = fileLocation.substring(index);
      const qIndex = key.indexOf('?');
      if (qIndex > -1) {
        key = key.substring(0, qIndex);
      }
      return key;
    } else {
      let key = fileLocation;
      const lastSlash = fileLocation.lastIndexOf('/');
      if (lastSlash > -1) {
        key = fileLocation.substring(lastSlash + 1);
      }
      const qIndex = key.indexOf('?');
      if (qIndex > -1) {
        key = key.substring(0, qIndex);
      }
      return key;
    }
  }

  viewEsignDocument(template: any) {
    if (!template?.fileName) return;
    const fileName = this.extractKey(template.fileName);
    this.esocService.getEPHfileObjectUrl({ fileName }).subscribe({
      next: (res) => {
        if (res?.success && res.url) {
          window.open(res.url, "_blank");
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (res?.message || "Invalid URL"));
        }
      },
      error: (err) => {
        this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (err?.message || err));
      }
    });
  }

  viewOriginalDocument(group: any) {
    if (!group?.items || group.items.length === 0) return;
    const firstItem = group.items[0];
    const fakeTemplate = {
      fileName: firstItem.fileName,
      fileOriginalName: firstItem.fileOriginalName || 'Document.pdf',
      fileLocation: firstItem.fileLocation || firstItem.fileName
    };

    this.viewOnlySignerTags = group.items.map((item: any) => ({
      name: item.recipientName || (item.isPatient ? 'Patient' : 'Signer'),
      isPatient: item.isPatient,
      signatureField: item.signatureFieldName || '',
      signatureField2: item.signatureFieldName2 || '',
      signatureField3: item.signatureFieldName3 || '',
      signatureField4: item.signatureFieldName4 || '',
      signatureField5: item.signatureFieldName5 || '',
      signatureField6: item.signatureFieldName6 || '',
      signatureField7: item.signatureFieldName7 || '',
      signatureField8: item.signatureFieldName8 || '',
      signatureField9: item.signatureFieldName9 || '',
      signatureField10: item.signatureFieldName10 || '',
      dateField: item.dateFieldName || '',
      dateField2: item.dateFieldName2 || '',
      dateField3: item.dateFieldName3 || '',
      dateField4: item.dateFieldName4 || '',
      dateField5: item.dateFieldName5 || '',
      dateField6: item.dateFieldName6 || '',
      dateField7: item.dateFieldName7 || '',
      dateField8: item.dateFieldName8 || '',
      dateField9: item.dateFieldName9 || '',
      dateField10: item.dateFieldName10 || '',
      signatureFieldOptional: !!item.signatureFieldNameOptional,
      signatureField2Optional: !!item.signatureFieldName2Optional,
      signatureField3Optional: !!item.signatureFieldName3Optional,
      signatureField4Optional: !!item.signatureFieldName4Optional,
      signatureField5Optional: !!item.signatureFieldName5Optional,
      signatureField6Optional: !!item.signatureFieldName6Optional,
      signatureField7Optional: !!item.signatureFieldName7Optional,
      signatureField8Optional: !!item.signatureFieldName8Optional,
      signatureField9Optional: !!item.signatureFieldName9Optional,
      signatureField10Optional: !!item.signatureFieldName10Optional,
      fillFields: this.copyFillFields(item.fillFields)
    }));

    this.loadPdfFormFields(fakeTemplate, true);
  }

  viewSignedDocument(historyItem: any) {
    if (!historyItem?.signedFileName) return;
    const fileName = this.extractKey(historyItem.signedFileName);
    this.esocService.getEPHfileObjectUrl({ fileName }).subscribe({
      next: (res) => {
        if (res?.success && res.url) {
          window.open(res.url, "_blank");
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (res?.message || "Invalid URL"));
        }
      },
      error: (err) => {
        this.messageHandlerService.generateToastMessage("error", "", "Error viewing file: " + (err?.message || err));
      }
    });
  }

  downloadAuditLog(historyItem: any) {
    if (!historyItem?._id) return;
    const auditId = historyItem.sendGroupId || historyItem._id;
    const fileName = `audit-${auditId}.pdf`;
    this.esocService.getEPHfileObjectUrl({ fileName }).subscribe({
      next: (res) => {
        if (res?.success && res.url) {
          const link = document.createElement("a");
          link.href = res.url;
          link.target = "_blank";
          link.download = fileName;
          link.click();
        } else {
          this.messageHandlerService.generateToastMessage("error", "", "Error downloading audit log: " + (res?.message || "Invalid URL"));
        }
      },
      error: (err) => {
        this.messageHandlerService.generateToastMessage("error", "", "Error downloading audit log: " + (err?.message || err));
      }
    });
  }

  getSignersForTagging(): any[] {
    const list = [];
    if (this.selectedEsocRecord) {
      const patientName = this.selectedEsocRecord.patientName || 'Patient';
      list.push({
        id: 'patient',
        name: patientName,
        isPatient: true
      });
    }
    this.additionalRecipients.forEach((r, idx) => {
      list.push({
        id: `recipient-${idx}`,
        name: r.name,
        isPatient: false,
        recipientIndex: idx
      });
    });
    return list;
  }

  /** True when a signer's tags give them at least one signature spot (slots 1-10). */
  private hasSignatureSpot(cfg: any): boolean {
    if (!cfg) return false;
    for (let i = 1; i <= 10; i++) {
      if (cfg[i === 1 ? 'signatureField' : `signatureField${i}`]) return true;
    }
    return false;
  }

  // IOHB-1655: the signers actually MAPPED to at least one signature field somewhere in the
  // selected template(s). Used to make the send recipients the entities bound in the document
  // — not merely whoever is ticked in the Signers list.
  /**
   * Signer ids ('patient' / 'recipient-<idx>') that have at least one signature field mapped
   * across the selected templates. The tags cache is already keyed by signer id, so identity
   * is available here — callers deciding "is this person a recipient" must use this rather
   * than the name-based variant below, since two signers can legitimately share a name.
   */
  getMappedSignerIdsForSelectedTemplates(): Set<string> {
    const ids = new Set<string>();
    const signers = this.getSignersForTagging();
    (this.selectedTemplates || []).forEach((t: any) => {
      const tags = this.templateSignerTagsCache[t.fileName] || {};
      signers.forEach((s: any) => {
        const cfg = tags[s.id];
        if (!cfg) return;
        for (let i = 1; i <= 10; i++) {
          const key = i === 1 ? 'signatureField' : `signatureField${i}`;
          if (cfg[key]) { ids.add(s.id); break; }
        }
      });
    });
    return ids;
  }

  /** Display-only convenience. Not for identity checks — see getMappedSignerIdsForSelectedTemplates(). */
  getMappedSignerNamesForSelectedTemplates(): Set<string> {
    const mappedIds = this.getMappedSignerIdsForSelectedTemplates();
    const names = new Set<string>();
    this.getSignersForTagging().forEach((s: any) => {
      if (mappedIds.has(s.id)) names.add((s.name || '').trim().toLowerCase());
    });
    return names;
  }

  getPdfFieldsOptions(): any[] {
    return (this.pdfFormFields || []).map(f => ({
      label: f.label + ` (${f.name})`,
      value: f.name
    }));
  }

  loadPdfFormFields(template: any, isViewOnly = false) {
    if (!template?.fileName) return;
    this.fillPdfZoomScale = 1.0;
    this.esignModalDisplay = false; // Hide the right E-Sign slider
    this.isViewOnlyFillablePdf = isViewOnly;
    this.selectedTemplateToFill = template;
    this.loadingPdfFields = true;
    this.pdfFormFields = [];
    this.originalPdfBytes = null;
    this.pdfDocToFill = null;
    this.numPagesToFill = 0;
    this.pagesToFill = [];

    const tempfileName = template.filledCustomFile?.fileName || template.fileName;
    const lastIndex = tempfileName.lastIndexOf("/");
    const fileName = tempfileName.substring(lastIndex + 1);

    console.log("loadPdfFormFields: Downloading PDF template...", fileName);
    this.esocService.downloadPdf(fileName).subscribe({
      next: async (arrayBuffer: ArrayBuffer) => {
        try {
          console.log("loadPdfFormFields: PDF downloaded successfully, size:", arrayBuffer?.byteLength);
          this.originalPdfBytes = arrayBuffer;

          const PDFLib = (window as any).PDFLib;
          if (!PDFLib) {
            throw new Error('PDF-lib is not loaded on this page.');
          }

          const pdfjsLib = (window as any).pdfjsLib;
          if (!pdfjsLib) {
            throw new Error('PDF.js is not loaded on this page.');
          }
          pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER_URL;

          // Pre-populate fields in PDF bytes first if we have cached values or autofill data
          let pdfBytesToLoad = this.originalPdfBytes;
          const cachedFields = this.filledFormValuesCache[template.fileName];

          const esocId = this.selectedEsocRecord?.patientEsocData?._id || this.selectedEsocRecord?._id;
          let autofillMap: Record<string, any> = {};

          if ((!cachedFields || cachedFields.length === 0) && esocId) {
            try {
              const autofillRes = await firstValueFrom(this.esocService.getAutofillData({ esocId }));
              if (autofillRes?.success && autofillRes?.data) {
                autofillMap = autofillRes.data;
              }
            } catch (err) {
              console.warn("Could not fetch PDF autofill data from server:", err);
            }
          }

          if (cachedFields && cachedFields.length > 0) {
            const pdfDoc = await PDFLib.PDFDocument.load(this.originalPdfBytes, { ignoreEncryption: true });
            const form = pdfDoc.getForm();
            cachedFields.forEach(cachedField => {
              try {
                const f = form.getField(cachedField.name);
                if (f) {
                  if (cachedField.type === 'checkbox') {
                    if (typeof cachedField.value === 'string' && cachedField.value !== '') {
                      // A pick-one field keeps which box was ticked (IOHB-1868)
                      tickCheckBoxByExportValue(f, cachedField.value);
                    } else if (cachedField.value) {
                      (f as any).check();
                    } else {
                      (f as any).uncheck();
                    }
                    if (typeof (f as any).defaultUpdateAppearances === 'function') {
                      (f as any).defaultUpdateAppearances();
                    }
                  } else if (cachedField.type === 'radio') {
                    if (cachedField.value) {
                      const options = (f as any).getOptions();
                      const valToSelect = options.find((opt: string) =>
                        opt === cachedField.value ||
                        opt.replace(/^\//, '') === cachedField.value ||
                        opt === `/${cachedField.value}` ||
                        opt.toLowerCase() === cachedField.value.toLowerCase()
                      );
                      try { (f as any).select(valToSelect || cachedField.value); } catch { /* cached value not a valid PDF option — skip (IOHB-1589 review) */ }
                      if (typeof (f as any).defaultUpdateAppearances === 'function') {
                        (f as any).defaultUpdateAppearances();
                      }
                    }
                  } else if (typeof (f as any).setText === 'function') {
                    (f as any).setText(cachedField.value || '');
                  } else if (typeof (f as any).select === 'function') {
                    (f as any).select(cachedField.value || '');
                  }
                }
              } catch (e) {
                console.warn(`Could not pre-fill field ${cachedField.name}:`, e);
              }
            });

            if (form.acroForm && form.acroForm.dict) {
              const PDFName = PDFLib.PDFName;
              const PDFBool = PDFLib.PDFBool;
              if (PDFName && PDFBool) {
                form.acroForm.dict.set(PDFName.of('NeedAppearances'), PDFBool.True);
              }
            }

            pdfBytesToLoad = await pdfDoc.save();
          } else if (Object.keys(autofillMap).length > 0) {
            const pdfDoc = await PDFLib.PDFDocument.load(this.originalPdfBytes, { ignoreEncryption: true });
            const form = pdfDoc.getForm();
            const fields = form.getFields();

            fields.forEach(f => {
              try {
                const name = f.getName();
                const cleanName = name.replace(/\[\d+\]/g, '').trim();
                const autoVal = autofillMap[name] !== undefined ? autofillMap[name] : autofillMap[cleanName];

                if (autoVal !== undefined && autoVal !== null && autoVal !== '') {
                  if (typeof (f as any).check === 'function') {
                    if (checkBoxExportValues(f).length > 1) {
                      // A pick-one field: tick the box the value names, if there is one (IOHB-1868)
                      tickCheckBoxByExportValue(f, String(autoVal));
                    } else if (Boolean(autoVal)) {
                      (f as any).check();
                    } else {
                      (f as any).uncheck();
                    }
                    if (typeof (f as any).defaultUpdateAppearances === 'function') {
                      (f as any).defaultUpdateAppearances();
                    }
                  } else if (typeof (f as any).select === 'function') {
                    const options = (f as any).getOptions ? (f as any).getOptions() : [];
                    const strVal = String(autoVal);
                    const valToSelect = options.find((opt: string) =>
                      opt === strVal ||
                      opt.replace(/^\//, '') === strVal ||
                      opt === `/${strVal}` ||
                      opt.toLowerCase() === strVal.toLowerCase()
                    );
                    try { (f as any).select(valToSelect || strVal); } catch { /* ignore invalid option */ }
                    if (typeof (f as any).defaultUpdateAppearances === 'function') {
                      (f as any).defaultUpdateAppearances();
                    }
                  } else if (typeof (f as any).setText === 'function') {
                    let textVal = String(autoVal);
                    if (autoVal instanceof Date || (typeof autoVal === 'string' && !isNaN(Date.parse(autoVal)) && autoVal.includes('T'))) {
                      try {
                        const d = new Date(autoVal);
                        textVal = `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
                      } catch {
                        textVal = String(autoVal);
                      }
                    }
                    (f as any).setText(textVal);
                  }
                }
              } catch (e) {
                console.warn(`Could not autofill field ${f.getName()}:`, e);
              }
            });

            if (form.acroForm && form.acroForm.dict) {
              const PDFName = PDFLib.PDFName;
              const PDFBool = PDFLib.PDFBool;
              if (PDFName && PDFBool) {
                form.acroForm.dict.set(PDFName.of('NeedAppearances'), PDFBool.True);
              }
            }

            pdfBytesToLoad = await pdfDoc.save();
          }

          // Load PDF into PDF.js
          console.log("loadPdfFormFields: Loading PDF into PDF.js...");
          const pdf = await pdfjsLib.getDocument({ data: new Uint8Array(pdfBytesToLoad) }).promise;
          console.log("loadPdfFormFields: PDF loaded in PDF.js, pages:", pdf.numPages);
          this.pdfDocToFill = pdf;
          this.numPagesToFill = pdf.numPages;
          this.pagesToFill = Array.from({ length: pdf.numPages }, (_, i) => i + 1);

          // Get fields list via pdf-lib for mapping
          console.log("loadPdfFormFields: Loading fields via pdf-lib...");
          const pdfDoc = await PDFLib.PDFDocument.load(this.originalPdfBytes, { ignoreEncryption: true });
          const form = pdfDoc.getForm();
          const fields = form.getFields();
          console.log("loadPdfFormFields: Fields parsed, count:", fields.length);

          const nonSignatureFieldKinds: Record<string, string> = {};
          const checkboxExportValues: Record<string, string[]> = {};
          const parsedFields = fields.map(f => {
            const name = f.getName();
            let type = 'text';
            let value: any = '';

            if (typeof (f as any).isChecked === 'function') {
              type = 'checkbox';
              const exportValues = checkBoxExportValues(f);
              if (exportValues.length > 1) {
                // A pick-one field: its value is the ticked box's export value, or false (IOHB-1868)
                checkboxExportValues[name] = exportValues;
                value = tickedCheckBoxExportValue(f);
              } else {
                value = (f as any).isChecked();
              }
              nonSignatureFieldKinds[name] = 'checkbox';
            } else if (typeof (f as any).getSelected === 'function') {
              type = 'radio';
              value = (f as any).getSelected() || '';
              nonSignatureFieldKinds[name] = 'choice field';
            } else if (typeof (f as any).getText === 'function') {
              type = 'text';
              value = (f as any).getText() || '';
              nonSignatureFieldKinds[name] = 'text box';
            } else {
              // fallback for other widget types
              type = 'text';
            }

            // Check if we have cached value for this field
            if (cachedFields) {
              const cachedField = cachedFields.find(c => c.name === name);
              if (cachedField) {
                value = cachedField.value;
              }
            } else if (Object.keys(autofillMap).length > 0) {
              const cleanName = name.replace(/\[\d+\]/g, '').trim();
              const autoVal = autofillMap[name] !== undefined ? autofillMap[name] : autofillMap[cleanName];

              if (autoVal !== undefined && autoVal !== null && autoVal !== '') {
                if (type === 'checkbox' && checkboxExportValues[name]) {
                  if (checkboxExportValues[name].includes(String(autoVal))) value = String(autoVal);
                } else if (type === 'checkbox') {
                  value = Boolean(autoVal);
                } else if (type === 'radio') {
                  value = String(autoVal);
                } else {
                  if (autoVal instanceof Date || (typeof autoVal === 'string' && !isNaN(Date.parse(autoVal)) && autoVal.includes('T'))) {
                    try {
                      const d = new Date(autoVal);
                      value = `${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}/${d.getFullYear()}`;
                    } catch {
                      value = String(autoVal);
                    }
                  } else {
                    value = String(autoVal);
                  }
                }
              }
            }

            const label = name
              .replace(/\[\d+\]/g, '')
              .replace(/[_\.-]/g, ' ')
              .replace(/([a-z])([A-Z])/g, '$1 $2')
              .trim();

            return {
              name,
              type,
              label: label.charAt(0).toUpperCase() + label.slice(1),
              value
            };
          }).filter(f => f !== null);
          this.nonSignatureFieldKinds = nonSignatureFieldKinds;
          this.checkboxExportValues = checkboxExportValues;

          if (parsedFields.length === 0) {
            this.messageHandlerService.generateToastMessage("warn", "No Fields Found", "This template does not contain any fillable form fields.");
            this.loadingPdfFields = false;
            this.cdr.detectChanges();
            return;
          }

          this.pdfFormFields = parsedFields;

          // Prepare signature and date options lists
          const allOptions = parsedFields.map(f => ({ label: `${f.label} (${f.name})`, value: f.name }));

          this.pdfSignatureFieldsOptions = parsedFields
            .filter(f => {
              const name = f.name.toLowerCase();
              return name.includes('sig') || name.includes('sign') || name.includes('signature');
            })
            .map(f => ({ label: `${f.label} (${f.name})`, value: f.name }));

          this.pdfDateFieldsOptions = parsedFields
            .filter(f => {
              const name = f.name.toLowerCase();
              return name.includes('date') || name.includes('time') || name.includes('day') || name.includes('dt') || name.includes('dob');
            })
            .map(f => ({ label: `${f.label} (${f.name})`, value: f.name }));

          // Fallback if no matching fields found
          if (this.pdfSignatureFieldsOptions.length === 0) {
            this.pdfSignatureFieldsOptions = allOptions;
          }
          if (this.pdfDateFieldsOptions.length === 0) {
            this.pdfDateFieldsOptions = allOptions;
          }

          // Initialize signerFieldTags for this template
          const signers = this.getSignersForTagging();
          this.signersForTagging = signers;
          const existingTags = this.templateSignerTagsCache[template.fileName] || {};
          this.isPatientSignatureRequired = this.templatePatientSigRequiredCache[template.fileName] !== undefined
            ? !!this.templatePatientSigRequiredCache[template.fileName]
            : (template.isPatientSignatureRequired !== undefined ? !!template.isPatientSignatureRequired : true);

          this.isPreparingForSigning = false;
          this.selectedFieldName = null;
          this.lastAssignedSignerId = null;
          this.lastAssignedSlotIndex = {};
          this.annotationIdToFieldNameMap = {};
          this.annotationIdToButtonValueMap = {};
          this.checkboxStateMap = {};
          this.fillPdfZoomScale = 1.0;
          this.signerFieldTags = {};
          signers.forEach(s => {
            this.signerFieldTags[s.id] = {
              signatureField: existingTags[s.id]?.signatureField || '',
              signatureField2: existingTags[s.id]?.signatureField2 || '',
              signatureField3: existingTags[s.id]?.signatureField3 || '',
              signatureField4: existingTags[s.id]?.signatureField4 || '',
              signatureField5: existingTags[s.id]?.signatureField5 || '',
              signatureField6: existingTags[s.id]?.signatureField6 || '',
              signatureField7: existingTags[s.id]?.signatureField7 || '',
              signatureField8: existingTags[s.id]?.signatureField8 || '',
              signatureField9: existingTags[s.id]?.signatureField9 || '',
              signatureField10: existingTags[s.id]?.signatureField10 || '',
              dateField: existingTags[s.id]?.dateField || '',
              dateField2: existingTags[s.id]?.dateField2 || '',
              dateField3: existingTags[s.id]?.dateField3 || '',
              dateField4: existingTags[s.id]?.dateField4 || '',
              dateField5: existingTags[s.id]?.dateField5 || '',
              dateField6: existingTags[s.id]?.dateField6 || '',
              dateField7: existingTags[s.id]?.dateField7 || '',
              dateField8: existingTags[s.id]?.dateField8 || '',
              dateField9: existingTags[s.id]?.dateField9 || '',
              dateField10: existingTags[s.id]?.dateField10 || '',
              signatureFieldOptional: existingTags[s.id]?.signatureFieldOptional || false,
              signatureField2Optional: existingTags[s.id]?.signatureField2Optional || false,
              signatureField3Optional: existingTags[s.id]?.signatureField3Optional || false,
              signatureField4Optional: existingTags[s.id]?.signatureField4Optional || false,
              signatureField5Optional: existingTags[s.id]?.signatureField5Optional || false,
              signatureField6Optional: existingTags[s.id]?.signatureField6Optional || false,
              signatureField7Optional: existingTags[s.id]?.signatureField7Optional || false,
              signatureField8Optional: existingTags[s.id]?.signatureField8Optional || false,
              signatureField9Optional: existingTags[s.id]?.signatureField9Optional || false,
              signatureField10Optional: existingTags[s.id]?.signatureField10Optional || false,
              fillFields: this.copyFillFields(existingTags[s.id]?.fillFields)
            };
          });

          console.log("loadPdfFormFields: All mappings initialized. Scheduling modal display on next tick.");
          setTimeout(() => {
            console.log("loadPdfFormFields: setTimeout callback. Setting fillableFormModalDisplay = true, loadingPdfFields = false");
            this.loadingPdfFields = false;
            this.fillableFormModalDisplay = true;
            this.cdr.detectChanges();
            console.log("loadPdfFormFields: setTimeout callback complete. detectChanges called. Modal visible =", this.fillableFormModalDisplay);
          }, 0);
        } catch (err: any) {
          console.error('Error loading PDF form fields:', err);
          this.messageHandlerService.generateToastMessage("error", "Error", "Failed to parse PDF form fields: " + (err.message || err));
          this.loadingPdfFields = false;
          this.cdr.detectChanges();
        }
      },
      error: (err) => {
        console.error('Error in downloadPdf:', err);
        this.messageHandlerService.generateToastMessage("error", "Error", "Failed to load PDF file: " + (err.message || err));
        this.loadingPdfFields = false;
        this.cdr.detectChanges();
      }
    });
  }

  renderFillablePdfPages() {
    console.log("renderFillablePdfPages: Starting render...", this.numPagesToFill);
    if (!this.pdfDocToFill) {
      console.warn("renderFillablePdfPages: pdfDocToFill is null/undefined!");
      return;
    }
    // Guard: prevent concurrent re-renders (e.g. from ngAfterViewChecked calling twice)
    if (this.renderingPdfPages) {
      return;
    }
    this.renderingPdfPages = true;
    this.cdr.detectChanges();

    setTimeout(() => {
      this.doRenderFillablePdfPages();
    }, 150);
  }

  private doRenderFillablePdfPages(): Promise<void> {
    console.log("renderFillablePdfPages: inside doRenderFillablePdfPages, doc exists");
    const pdfjsLib = (window as any).pdfjsLib;
    if (!pdfjsLib) {
      this.messageHandlerService.generateToastMessage("error", "Error", "Failed to render PDF visually: PDF.js is not loaded.");
      this.renderingPdfPages = false;
      this.cdr.detectChanges();
      return Promise.resolve();
    }

    const pages = Array.from({ length: this.numPagesToFill }, (_, i) => i + 1);

    let chain = Promise.resolve();
    pages.forEach((pageNum) => {
      chain = chain.then(() => this.renderPageCatchError(pageNum, pdfjsLib));
    });

    return chain.then(() => {
      console.log("renderFillablePdfPages: successfully rendered all page canvases");
      this.applyVisualIndicatorsToFields();
    }).catch((err: any) => {
      console.error('Error rendering fillable PDF pages:', err);
      this.messageHandlerService.generateToastMessage("error", "Error", "Failed to render PDF visually: " + (err.message || err));
    }).finally(() => {
      console.log("renderFillablePdfPages: Setting renderingPdfPages = false");
      this.renderingPdfPages = false;
      this.cdr.detectChanges();
      if (this.pendingReRender) {
        this.pendingReRender = false;
        this.renderFillablePdfPages();
      }
    });
  }

  private renderPageCatchError(pageNum: number, pdfjsLib: any): Promise<void> {
    return this.renderSinglePageCanvas(pageNum, pdfjsLib).catch((pageErr: any) => {
      console.error(`Error rendering page ${pageNum}:`, pageErr);
    });
  }

  private renderSinglePageCanvas(i: number, pdfjsLib: any): Promise<void> {
    let pageObj: any;
    return this.pdfDocToFill.getPage(i)
      .then((page: any) => {
        pageObj = page;
        return this.processPageAndRender(page, i);
      })
      .then(() => {
        return pageObj.getAnnotations();
      })
      .then((annotations: any) => {
        return this.processPageAnnotations(annotations, pageObj, i, pdfjsLib);
      })
      .then(() => {
        this.finalizePageRendering(i);
      });
  }

  processPageAndRender(page: any, i: number): Promise<any> {
    const canvas = document.getElementById('fill-pdf-canvas-' + i) as HTMLCanvasElement;
    const annotationDiv = document.getElementById('fill-pdf-annotations-' + i) as HTMLDivElement;
    console.log(`renderFillablePdfPages: page ${i} elements - canvas:`, !!canvas, "annotations:", !!annotationDiv);
    if (!canvas || !annotationDiv) {
      return Promise.reject(new Error('Canvas or annotations elements not found'));
    }

    const context = canvas.getContext('2d');
    const viewport = page.getViewport({ scale: 1.0 });
    const scaleVal = (820 * this.fillPdfZoomScale) / viewport.width;
    const scaledViewport = page.getViewport({ scale: scaleVal });

    canvas.width = scaledViewport.width;
    canvas.height = scaledViewport.height;

    const renderContext = {
      canvasContext: context,
      viewport: scaledViewport
    };

    this.currentPageScaleMap[i] = scaleVal;

    return page.render(renderContext).promise;
  }

  processPageAnnotations(annotations: any, page: any, i: number, pdfjsLib: any): Promise<void> {
    const annotationDiv = document.getElementById('fill-pdf-annotations-' + i) as HTMLDivElement;
    if (!annotationDiv) {
      return Promise.resolve();
    }

    annotationDiv.innerHTML = '';
    const scaleVal = this.currentPageScaleMap[i] || 1.0;
    annotationDiv.style.setProperty('--scale-factor', scaleVal.toString());

    annotations.forEach((annot: any) => {
      if (annot.id && annot.fieldName) {
        this.annotationIdToFieldNameMap[annot.id] = annot.fieldName;
      }
      if (annot.id && annot.buttonValue != null) {
        this.annotationIdToButtonValueMap[annot.id] = annot.buttonValue;
      } else if (annot.id && annot.checkBox && annot.exportValue != null) {
        // A checkbox's export value tells apart the boxes of a pick-one field (IOHB-1868)
        this.annotationIdToButtonValueMap[annot.id] = annot.exportValue;
      }
    });

    const scaledViewport = page.getViewport({ scale: scaleVal });
    const renderTask = pdfjsLib.AnnotationLayer.render({
      viewport: scaledViewport.clone({ dontFlip: true }),
      div: annotationDiv,
      annotations: annotations,
      page: page,
      linkService: {
        getDestinationHash: () => '#',
        getAnchorUrl: () => '#',
        navigateTo: () => {},
        // pdf.js also calls these for link annotations. Without addLinkAttributes a page containing a
        // hyperlink throws mid-render and the form fields after the link never appear (IOHB-1842).
        // Left as no-ops so links stay inert and a click can never navigate away from the document.
        addLinkAttributes: () => {},
        goToDestination: () => {},
        executeNamedAction: () => {},
      },
      downloadManager: null,
      imageResourcesPath: '',
      renderInteractiveForms: true
    });

    return renderTask?.promise || Promise.resolve();
  }

  finalizePageRendering(i: number): void {
    const annotationDiv = document.getElementById('fill-pdf-annotations-' + i) as HTMLDivElement;
    if (!annotationDiv) {
      return;
    }

    annotationDiv.querySelectorAll('input, textarea').forEach((el: any) => {
      el.setAttribute('autocomplete', 'off');
      el.setAttribute('autocorrect', 'off');
      el.setAttribute('autocapitalize', 'off');
      el.setAttribute('spellcheck', 'false');
    });

    if (!this.isViewOnlyFillablePdf) {
      this.setupFieldEventListeners(annotationDiv);
    }

    this.setupDatePickerOverlays(annotationDiv);

    if (this.isViewOnlyFillablePdf) {
      this.applyViewOnlyRestrictions(annotationDiv);
    }

    this.restoreTypedValuesToDom(annotationDiv);
  }

  private setupFieldEventListeners(annotationDiv: HTMLElement): void {
    const sections = annotationDiv.querySelectorAll('section');
    sections.forEach((section: HTMLElement) => {
      section.addEventListener('click', (event) => {
        if (!this.isPreparingForSigning) return;

        const annotId = section.dataset?.annotationId;
        let name = annotId ? this.annotationIdToFieldNameMap[annotId] : null;

        const inputEl = section.querySelector('input, button, textarea, select') as any;
        if (!name && inputEl) {
          name = inputEl.name;
        }

        if (!name) return;

        event.preventDefault();
        event.stopPropagation();

        const clickedIsDate = this.isDateFieldName(name);

        // Manual date mapping (the old auto-attach-to-last-signer is removed). OPTION 2: if a DATE
        // field is already selected and the user now clicks a signature field that is ALREADY mapped
        // to a person, map the selected date to THAT person — a quick way to pick the person via
        // their signature on the PDF. Otherwise this click just selects the field.
        const selected = this.selectedFieldName;
        const owner = (!clickedIsDate && selected && name !== selected && this.isDateFieldName(selected))
          ? this.findSignerOwningSignature(name)
          : null;
        if (owner) {
          this.assignSelectedFieldToSigner(owner.id); // uses the still-selected date field
        } else {
          this.selectedFieldName = name;
          this.applyVisualIndicatorsToFields();
        }
      });

      if (!this.isPreparingForSigning) {
        const inputEl = section.querySelector('input, textarea, select') as any;
        if (inputEl && !inputEl.dataset.hasSyncListener) {
          const annotId = section.dataset?.annotationId;
          const fieldName = (annotId ? this.annotationIdToFieldNameMap[annotId] : null) || inputEl.name;
          const buttonExportValue = annotId ? this.annotationIdToButtonValueMap[annotId] : null;

          if (fieldName) {
            this.registerSyncListeners(inputEl, fieldName, buttonExportValue);
          }
        }
      }
    });
  }

  private registerSyncListeners(inputEl: any, fieldName: string, buttonExportValue: string): void {
    // One box of a pick-one checkbox field, whose answer is buttonExportValue (IOHB-1868)
    const pickOne = inputEl.type === 'checkbox' && this.isPickOneCheckbox(fieldName);
    const syncToModel = () => {
      const field = this.pdfFormFields.find(f => f.name === fieldName);
      if (!field) return;

      if (inputEl.type === 'checkbox') {
        if (!pickOne) {
          field.value = inputEl.checked;
        } else if (inputEl.checked) {
          field.value = buttonExportValue;
        } else if (field.value === buttonExportValue) {
          field.value = false;
        }
      } else if (inputEl.type === 'radio') {
        if (inputEl.checked) {
          field.value = buttonExportValue || inputEl.value || inputEl.getAttribute('value') || '';
          field.type = 'radio';
        }
      } else {
        field.value = inputEl.value;
      }
    };
    inputEl.addEventListener('change', syncToModel);
    inputEl.addEventListener('input', syncToModel);
    inputEl.dataset.hasSyncListener = 'true';

    if (inputEl.type === 'checkbox' && !inputEl.dataset.hasClickListener) {
      if (!pickOne) {
        this.checkboxStateMap[fieldName] = inputEl.checked;
      } else if (inputEl.checked) {
        this.checkboxStateMap[fieldName] = buttonExportValue;
      } else if (this.checkboxStateMap[fieldName] === undefined) {
        this.checkboxStateMap[fieldName] = false;
      }

      inputEl.addEventListener('click', (e: MouseEvent) => {
        e.preventDefault();
        // After "Prepare for Signing" a click selects the field for a signer (setupFieldEventListeners), so let it
        // through and leave the tick as it is (IOHB-1868).
        if (this.isPreparingForSigning) return;
        e.stopImmediatePropagation();

        const newState = this.nextCheckboxState(fieldName, pickOne, buttonExportValue);
        this.checkboxStateMap[fieldName] = newState;

        setTimeout(() => {
          inputEl.checked = pickOne ? newState === buttonExportValue : newState;
          this.showCheckboxStateOnOtherBoxes(inputEl, fieldName);
          const field = this.pdfFormFields.find(f => f.name === fieldName);
          if (field) {
            field.value = newState;
            field.type = 'checkbox';
          }
        }, 0);
      }, true);
      inputEl.dataset.hasClickListener = 'true';
    }
  }

  /** True for a checkbox field whose boxes share a name but have different export values (IOHB-1868). */
  private isPickOneCheckbox(fieldName: string): boolean {
    return (this.checkboxExportValues[fieldName]?.length || 0) > 1;
  }

  /** The state a click on a checkbox box leads to: a box of a pick-one field ticks its own answer, or clears it when it
   *  is already ticked; any other checkbox toggles (IOHB-1868). */
  private nextCheckboxState(fieldName: string, pickOne: boolean, exportValue: string): boolean | string {
    const current = this.checkboxStateMap[fieldName];
    if (!pickOne) return !current;
    return current === exportValue ? false : exportValue;
  }

  /** The export value of a rendered checkbox box, from its annotation (IOHB-1868). */
  private checkboxExportValueOf(inputEl: any): string | null {
    const annotId = (inputEl.closest('section') as HTMLElement)?.dataset?.annotationId;
    return (annotId ? this.annotationIdToButtonValueMap[annotId] : null) ?? inputEl.getAttribute?.('exportValue') ?? null;
  }

  /** Shows a checkbox field's tracked state on its other rendered boxes: every copy of a checkbox shows the same
   *  tick, and a pick-one field shows only its ticked answer (IOHB-1868). */
  private showCheckboxStateOnOtherBoxes(inputEl: any, fieldName: string): void {
    const state = this.checkboxStateMap[fieldName];
    document.querySelectorAll('.fillable-pdf-body .annotationLayer input[type="checkbox"]').forEach((other: any) => {
      if (other === inputEl) return;
      const annotId = (other.closest('section') as HTMLElement)?.dataset?.annotationId;
      const otherName = (annotId ? this.annotationIdToFieldNameMap[annotId] : null) || other.name;
      if (otherName !== fieldName) return;
      other.checked = this.isPickOneCheckbox(fieldName) ? state === this.checkboxExportValueOf(other) : !!state;
    });
  }

  private setupDatePickerOverlays(annotationDiv: HTMLElement): void {
    const pageInputs = annotationDiv.querySelectorAll('input');
    pageInputs.forEach((inputEl: HTMLInputElement) => {
      const name = inputEl.name ? inputEl.name.toLowerCase() : '';
      const id = inputEl.id ? inputEl.id.toLowerCase() : '';
      const isDate = name.includes('date') || id.includes('date') || name.includes('dob') || id.includes('dob');
      if (!isDate) return;

      let currentVal = inputEl.value;
      let dateForOverlay = '';
      if (currentVal) {
        const matches = currentVal.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})$/);
        if (matches) {
          const m = matches[1].padStart(2, '0');
          const d = matches[2].padStart(2, '0');
          const y = matches[3];
          dateForOverlay = `${y}-${m}-${d}`;
          inputEl.value = `${m}-${d}-${y}`;
        }
      }

      const overlay = document.createElement('input');
      overlay.type = 'date';
      overlay.value = dateForOverlay;
      overlay.className = 'date-picker-overlay';

      overlay.style.position = 'absolute';
      overlay.style.left = inputEl.style.left;
      overlay.style.top = inputEl.style.top;
      overlay.style.width = inputEl.style.width;
      overlay.style.height = inputEl.style.height;
      overlay.style.transform = inputEl.style.transform;
      overlay.style.transformOrigin = inputEl.style.transformOrigin;
      overlay.style.opacity = '0';
      overlay.style.cursor = 'pointer';
      overlay.style.zIndex = '10';

      overlay.addEventListener('change', () => {
        const selectedVal = overlay.value;
        if (selectedVal) {
          const parts = selectedVal.split('-');
          if (parts.length === 3) {
            inputEl.value = `${parts[1]}-${parts[2]}-${parts[0]}`;
          }
        } else {
          inputEl.value = '';
        }

        inputEl.dispatchEvent(new Event('input', { bubbles: true }));
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (inputEl.parentElement) {
        const hasOverlay = !!inputEl.parentElement.querySelector('.date-picker-overlay');
        if (hasOverlay) return;

        inputEl.style.color = 'transparent';
        inputEl.style.caretColor = 'transparent';
        inputEl.parentElement.appendChild(overlay);
      }
    });
  }

  private applyViewOnlyRestrictions(annotationDiv: HTMLElement): void {
    const allInputs = annotationDiv.querySelectorAll('input, textarea, select');
    allInputs.forEach((el: any) => {
      el.disabled = true;
      el.readOnly = true;
      el.style.pointerEvents = 'none';
    });
  }

  private restoreTypedValuesToDom(annotationDiv: HTMLElement): void {
    if (!this.pdfFormFields?.length) {
      return;
    }
    const inputs = annotationDiv.querySelectorAll('input, textarea, select');
    inputs.forEach((inputEl: any) => {
      const annotId = (inputEl.closest('section') as HTMLElement)?.dataset?.annotationId;
      const fieldName = (annotId ? this.annotationIdToFieldNameMap[annotId] : null) || inputEl.name;
      if (!fieldName) {
        return;
      }
      const field = this.pdfFormFields.find(f => f.name === fieldName);
      if (field?.value === undefined) {
        return;
      }
      if (inputEl.type === 'checkbox') {
        // A pick-one field shows only its ticked answer (IOHB-1868)
        inputEl.checked = this.isPickOneCheckbox(fieldName) ? field.value === this.checkboxExportValueOf(inputEl) : !!field.value;
      } else if (inputEl.type === 'radio') {
        const btnVal = annotId ? this.annotationIdToButtonValueMap[annotId] : inputEl.value;
        inputEl.checked = (field.value === btnVal);
      } else {
        inputEl.value = field.value || '';
        this.restoreDateOverlayValue(inputEl, field.value);
      }
    });
  }

  private restoreDateOverlayValue(inputEl: any, value: string): void {
    if (!inputEl.parentElement || !value) {
      return;
    }
    const overlay = inputEl.parentElement.querySelector('.date-picker-overlay') as HTMLInputElement;
    if (!overlay) {
      return;
    }
    const parts = value.includes('-') ? value.split('-') : value.split('/');
    if (parts.length !== 3) {
      return;
    }
    if (parts[0].length === 4) {
      overlay.value = `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
    } else {
      overlay.value = `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
    }
  }

  applyVisualIndicatorsToFields() {
    // Clear any existing badges first
    const existingBadges = document.querySelectorAll('.field-assignment-badge');
    existingBadges.forEach(b => b.remove());

    const allSections = document.querySelectorAll('.fillable-pdf-body .annotationLayer section');
    allSections.forEach((el: any) => {
      el.classList.remove('assigned-sig-field', 'assigned-date-field', 'unassigned-sig-field');
      el.style.border = '';
      el.style.backgroundColor = '';
      el.style.boxShadow = '';
    });

    const allInputs = document.querySelectorAll('.fillable-pdf-body .annotationLayer input, .annotationLayer button, .annotationLayer textarea, .annotationLayer select');
    allInputs.forEach((el: any) => {
      el.style.border = '';
      el.style.backgroundColor = '';
      el.style.boxShadow = '';
    });

    // Scan all pages
    for (let i = 1; i <= this.numPagesToFill; i++) {
      const annotationDiv = document.getElementById('fill-pdf-annotations-' + i) as HTMLDivElement;
      if (!annotationDiv) continue;

      const sections = annotationDiv.querySelectorAll('section');
      // Where each field sits on the page, read once before the borders below change, to place the tags
      const boxOf = new Map<Element, DOMRect>(Array.from(sections, (s) => [s, s.getBoundingClientRect()]));
      const fieldBoxes = Array.from(boxOf.values());
      sections.forEach((section: HTMLElement) => {
        const annotId = section.getAttribute('data-annotation-id');
        let name = annotId ? this.annotationIdToFieldNameMap[annotId] : null;

        const inputEl = section.querySelector('input, button, textarea, select') as any;
        if (!name && inputEl) {
          name = inputEl.name;
        }

        if (!name) return;

        // Check if assigned to any signer
        let assignedSigner: any = null;
        let assignedSlot = ''; // 'sig1', 'sig2', 'sig3', 'date1', 'date2', 'date3'
        let config: any = null;

        if (this.isViewOnlyFillablePdf) {
          this.viewOnlySignerTags.forEach(s => {
            for (let idx = 1; idx <= 10; idx++) {
              const sigKey = idx === 1 ? 'signatureField' : `signatureField${idx}`;
              const dateKey = idx === 1 ? 'dateField' : `dateField${idx}`;
              if (s[sigKey] === name) {
                assignedSigner = s;
                assignedSlot = `sig${idx}`;
                config = s;
                break;
              } else if (s[dateKey] === name) {
                assignedSigner = s;
                assignedSlot = `date${idx}`;
                config = s;
                break;
              }
            }
          });
        } else {
          this.signersForTagging.forEach(s => {
            const cfg = this.signerFieldTags[s.id];
            if (cfg) {
              for (let idx = 1; idx <= 10; idx++) {
                const sigKey = idx === 1 ? 'signatureField' : `signatureField${idx}`;
                const dateKey = idx === 1 ? 'dateField' : `dateField${idx}`;
                if (cfg[sigKey] === name) {
                  assignedSigner = s;
                  assignedSlot = `sig${idx}`;
                  config = cfg;
                  break;
                } else if (cfg[dateKey] === name) {
                  assignedSigner = s;
                  assignedSlot = `date${idx}`;
                  config = cfg;
                  break;
                }
              }
            }
          });
        }

        // Otherwise the field may be one a signer fills in (IOHB-1779).
        let fillField: EsignFillField | null = null;
        if (!assignedSigner) {
          const owners = this.isViewOnlyFillablePdf
            ? this.viewOnlySignerTags.map(s => ({ signer: s, fillFields: s.fillFields }))
            : this.signersForTagging.map(s => ({ signer: s, fillFields: this.signerFieldTags[s.id]?.fillFields }));
          for (const owner of owners) {
            const match = (owner.fillFields || []).find((f: EsignFillField) => f.name === name);
            if (match) {
              assignedSigner = owner.signer;
              assignedSlot = 'fill';
              fillField = match;
              break;
            }
          }
        }

        // Ensure fields are interactive for typing/focusing based on isPreparingForSigning
        if (this.isPreparingForSigning) {
          section.style.cursor = 'pointer';
          section.style.pointerEvents = 'auto';
          if (inputEl) {
            inputEl.style.cursor = 'pointer';
            inputEl.readOnly = false;
            inputEl.disabled = false;
            inputEl.tabIndex = -1;
            inputEl.style.pointerEvents = 'none'; // Click falls through to section
          }
        } else {
          section.style.cursor = 'text';
          section.style.pointerEvents = 'auto';
          if (inputEl) {
            inputEl.style.cursor = 'text';
            inputEl.tabIndex = 0;
            inputEl.readOnly = this.isViewOnlyFillablePdf;
            inputEl.disabled = this.isViewOnlyFillablePdf;
            inputEl.style.pointerEvents = this.isViewOnlyFillablePdf ? 'none' : 'auto';
          }
        }

        const nameLower = name.toLowerCase();
        const isLikelySig = (nameLower.includes('sig') || nameLower.includes('sign') || nameLower.includes('signature')) && !nameLower.includes('designat');

        if (!this.isPreparingForSigning && inputEl) {
          if (isLikelySig) {
            // signature fields don't need text input - disable pointer events so right clicks hit section cleanly
            inputEl.style.pointerEvents = 'none';
          } else {
            inputEl.style.pointerEvents = this.isViewOnlyFillablePdf ? 'none' : 'auto';
          }
        }

        const isSelected = this.selectedFieldName === name;

        if (assignedSigner) {
          const isDateSlot = assignedSlot.startsWith('date');
          // Per-person colour: a signer's signature AND all their date fields share ONE unique
          // colour (previously every non-patient signer shared the same green and all date fields
          // were orange, so different people looked identical).
          const personColor = this.getSignerColor(assignedSigner);
          const color = personColor.border;
          const bgColor = personColor.bg;

          section.style.border = `2px solid ${color}`;
          section.style.backgroundColor = bgColor;

          if (inputEl) {
            inputEl.style.border = `2px solid ${color}`;
            inputEl.style.backgroundColor = bgColor;
            inputEl.style.boxSizing = 'border-box';
          }

          if (isSelected) {
            section.style.boxShadow = '0 0 0 3px #fbc02d';
            if (inputEl) {
              inputEl.style.boxShadow = '0 0 0 3px #fbc02d';
            }
          }

          // Add badge
          let isOptional = false;
          if (!isDateSlot && assignedSlot.startsWith('sig')) {
            const idxNum = parseInt(assignedSlot.replace('sig', ''), 10);
            const optKey = idxNum === 1 ? 'signatureFieldOptional' : `signatureField${idxNum}Optional`;
            isOptional = !!config?.[optKey];
          }

          const badge = document.createElement('span');
          badge.className = 'field-assignment-badge';
          badge.innerText = assignedSlot === 'fill'
            ? `Fills in: ${assignedSigner.name}${fillField?.required ? ' (Required)' : ''}`
            : isDateSlot ? `Date: ${assignedSigner.name}` : `${assignedSigner.name} (${isOptional ? 'Optional' : 'Compulsory'})`;
          badge.style.position = 'absolute';
          this.placeFieldTag(badge, this.tagWouldCoverFieldAbove(boxOf.get(section), fieldBoxes));
          badge.style.backgroundColor = color;
          badge.style.color = '#fff';
          badge.style.fontSize = '9px';
          badge.style.fontWeight = 'bold';
          badge.style.padding = '1px 4px';
          badge.style.borderRadius = '3px';
          badge.style.whiteSpace = 'nowrap';
          badge.style.zIndex = '50';
          section.appendChild(badge);
        } else {
          // Unassigned fields: Keep completely clean, no borders or badges
          section.style.border = isSelected ? '2px dashed #fbc02d' : '';
          section.style.backgroundColor = isSelected ? 'rgba(251, 192, 45, 0.1)' : '';
          if (inputEl) {
            inputEl.style.border = isSelected ? '2px dashed #fbc02d' : '';
            inputEl.style.backgroundColor = isSelected ? 'rgba(251, 192, 45, 0.1)' : '';
          }
          if (isSelected) {
            section.style.boxShadow = '0 0 0 3px #fbc02d';
            if (inputEl) {
              inputEl.style.boxShadow = '0 0 0 3px #fbc02d';
            }
          }
        }
      });
    }
  }

  // The room a field's tag takes above the field on the Prepare for Signing page (the tag sits this far up).
  private readonly fieldTagRoomPx = 18;

  /** True when a tag drawn above this field would cover another field: one that starts higher up, reaches into
   *  the tag's room above this field and overlaps it sideways, as stacked boxes (or a larger box this field sits
   *  in) do. A field shorter than that room keeps its tag above, since the tag wouldn't fit inside it, and so does
   *  a page that isn't laid out yet (its boxes are empty). */
  tagWouldCoverFieldAbove(box: DOMRect, boxes: DOMRect[]): boolean {
    if (!box || box.height < this.fieldTagRoomPx) return false;
    return boxes.some((other) => other !== box && other.height > 0
      && other.top < box.top && other.bottom > box.top - this.fieldTagRoomPx
      && other.left < box.right && other.right > box.left);
  }

  /** Puts a field's tag just above the field, or, when it would cover another field there (stacked boxes), inside
   *  the field's own box instead: in the top right corner, where a value typed in the box rarely reaches, cut short
   *  with "..." if the box is narrower (IOHB-2159). */
  private placeFieldTag(badge: HTMLElement, inside: boolean): void {
    badge.style.top = inside ? '0' : `-${this.fieldTagRoomPx}px`;
    if (inside) {
      badge.style.right = '0';
      badge.style.maxWidth = '100%';
      badge.style.overflow = 'hidden';
      badge.style.textOverflow = 'ellipsis';
    } else {
      badge.style.left = '0';
    }
  }

  private readonly esignPatientColor = { border: '#2e7d32', bg: 'rgba(46,125,50,0.15)' }; // patient = green
  private readonly esignSignerPalette = [
    { border: '#1565c0', bg: 'rgba(21,101,192,0.15)' },  // blue
    { border: '#6a1b9a', bg: 'rgba(106,27,154,0.15)' },  // purple
    { border: '#c62828', bg: 'rgba(198,40,40,0.15)' },   // red
    { border: '#00838f', bg: 'rgba(0,131,143,0.15)' },   // teal
    { border: '#ef6c00', bg: 'rgba(239,108,0,0.15)' },   // orange
    { border: '#4527a0', bg: 'rgba(69,39,160,0.15)' },   // deep indigo
    { border: '#ad1457', bg: 'rgba(173,20,87,0.15)' },   // pink
    { border: '#5d4037', bg: 'rgba(93,64,55,0.15)' },    // brown
  ];

  /** One UNIQUE colour per person (border + translucent bg), shared by that person's signature and
   *  all their date fields. Patient = green; each other signer takes the next palette colour by its
   *  position in the signer list (cycles if there are more signers than palette entries). */
  getSignerColor(signer: any): { border: string; bg: string } {
    if (!signer) return { border: '#9ca3af', bg: 'rgba(156,163,175,0.15)' };
    if (signer.isPatient) return this.esignPatientColor;
    const others = (this.signersForTagging || []).filter((s) => s && !s.isPatient);
    const idx = others.findIndex((s) => s.id === signer.id);
    return this.esignSignerPalette[(idx >= 0 ? idx : 0) % this.esignSignerPalette.length];
  }

  /** True when a field NAME reads as a date field (kept as-is per requirement — the PDF fields are
   *  already typed by name/format; date fields contain date/dob/time). */
  private isDateFieldName(fieldName: string): boolean {
    const l = (fieldName || '').toLowerCase();
    return l.includes('date') || l.includes('dob') || l.includes('time') || l.includes('dt');
  }

  /** Why a field can't take a signature, or null when it can. A signature replaces whatever its field holds
   *  when the document is signed, so checkboxes and choice fields are always refused, and a text box only
   *  when it would lose something: it already contains text, or IO Doc fills it in automatically (io_ fields).
   *  Empty text boxes, text boxes named as signature lines ("Patient Signature", "Sign Here"), push buttons
   *  and fields whose type wasn't read stay allowed. "sig"/"sign" must stand alone, so e.g. "I hereby
   *  designate" is not a signature line. */
  private signatureSpotProblem(fieldName: string): string | null {
    const kind = this.nonSignatureFieldKinds[fieldName];
    if (!kind) return null;
    if (kind !== 'text box') {
      return `"${fieldName}" is a ${kind}, not a signature field. A signature placed there would erase its content when the document is signed. Please choose a signature field.`;
    }
    if (/signature|(^|[^a-z])sign?([^a-z]|$)/i.test(fieldName)) return null;
    if (fieldName.startsWith('io_')) {
      return `"${fieldName}" is filled in automatically by ioDoc. A signature placed there would replace that information when the document is signed. Please choose a signature field.`;
    }
    const value = (this.pdfFormFields || []).find(f => f.name === fieldName)?.value;
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return `"${fieldName}" already contains text. A signature placed there would replace that text when the document is signed. Clear the text or choose a signature field.`;
    }
    return null;
  }

  /** The signer who currently owns a given field as one of THEIR signature slots, if any. Used for
   *  the "click a mapped signature to map the selected date to that person" (indirect) flow. */
  private findSignerOwningSignature(fieldName: string): any | null {
    for (const s of this.signersForTagging || []) {
      const cfg = this.signerFieldTags[s.id];
      if (!cfg) continue;
      for (let idx = 1; idx <= 10; idx++) {
        const sigKey = idx === 1 ? 'signatureField' : `signatureField${idx}`;
        if (cfg[sigKey] === fieldName) return s;
      }
    }
    return null;
  }

  // IOHB-1779: a text box picked for a signer waits here until the user chooses Signature or Fill in.
  pendingTextBoxAssignment: { signerId: string; fieldName: string } | null = null;

  /** Assigns the selected field to a signer. Checkboxes, radio groups and dropdowns become fields that signer
   *  fills in; a text box asks each time whether it is their signature spot or a field they fill in (`as`
   *  carries the answer); date fields keep their auto-filled date slots; anything else is a signature spot.
   *  A field belongs to one signer only. */
  assignSelectedFieldToSigner(signerId: string, as?: 'signature' | 'fill') {
    if (!this.selectedFieldName) {
      this.messageHandlerService.generateToastMessage("info", "Information", "Please select a field in the PDF first by clicking on it.");
      return;
    }

    // A patient who isn't signing this document can't be given fields: they would get no link, or a link they
    // weren't meant to get (IOHB-1865).
    if (signerId === 'patient' && !this.isPatientSignatureRequired) {
      this.messageHandlerService.generateToastMessage(
        "warn",
        "Patient isn't signing",
        "Tick \"Patient signature required\" to give the patient fields on this document."
      );
      return;
    }

    const config = this.signerFieldTags[signerId];
    if (!config) return;

    const fieldName = this.selectedFieldName;
    const kind = this.nonSignatureFieldKinds[fieldName];
    if (kind === 'checkbox' || kind === 'choice field') {
      as = 'fill';
    } else if (kind === 'text box' && !as && !this.isDateFieldName(fieldName)) {
      this.pendingTextBoxAssignment = { signerId, fieldName };
      this.cdr.detectChanges();
      return;
    }
    this.pendingTextBoxAssignment = null;

    // A signature replaces what its field holds when the document is signed, so a field that would lose
    // something can't take one (see signatureSpotProblem). Dates keep their own handling, and a field the
    // signer fills in keeps its content.
    const problem = as === 'fill' || this.isDateFieldName(fieldName) ? null : this.signatureSpotProblem(fieldName);
    if (problem) {
      this.messageHandlerService.generateToastMessage("warn", "Not a signature field", problem);
      return;
    }

    // Clear this field from every signer's signature, date and fill-in fields first: one signer per field
    this.signersForTagging.forEach(s => {
      const cfg = this.signerFieldTags[s.id];
      if (cfg) {
        for (let idx = 1; idx <= 10; idx++) {
          const sigKey = idx === 1 ? 'signatureField' : `signatureField${idx}`;
          const dateKey = idx === 1 ? 'dateField' : `dateField${idx}`;
          if (cfg[sigKey] === this.selectedFieldName) cfg[sigKey] = '';
          if (cfg[dateKey] === this.selectedFieldName) cfg[dateKey] = '';
        }
        if (cfg.fillFields?.length) cfg.fillFields = cfg.fillFields.filter(f => f.name !== fieldName);
      }
    });

    if (as === 'fill') {
      // Required unless the agency ticks "Make optional", the same as a signature (IOHB-1884). A checkbox starts
      // optional: left unticked it counts as empty, so a required one would warn the signer every time.
      config.fillFields = [...(config.fillFields || []), { name: fieldName, required: kind !== 'checkbox' }];
      this.lastAssignedSignerId = signerId;
      this.selectedFieldName = null;
      this.applyVisualIndicatorsToFields();
      this.cdr.detectChanges();
      return;
    }

    const nameLower = this.selectedFieldName.toLowerCase();
    const isDate = nameLower.includes('date') || nameLower.includes('dob') || nameLower.includes('time') || nameLower.includes('dt');

    if (isDate) {
      // Manual mapping: a date belongs to the PERSON — drop it into their next free date slot. No
      // auto-pairing with a specific signature slot (the signing page fills ALL of a person's dates
      // when that person signs). One person can hold multiple date fields.
      let assigned = false;
      for (let idx = 1; idx <= 10; idx++) {
        const dateKey = idx === 1 ? 'dateField' : `dateField${idx}`;
        if (!config[dateKey]) { config[dateKey] = this.selectedFieldName; assigned = true; break; }
      }
      if (!assigned) config.dateField = this.selectedFieldName; // all 10 date slots taken -> override first
    } else {
      // Signature assignment: first empty signature slot (override slot 1 if all are full).
      let assigned = false;
      for (let idx = 1; idx <= 10; idx++) {
        const sigKey = idx === 1 ? 'signatureField' : `signatureField${idx}`;
        if (!config[sigKey]) { config[sigKey] = this.selectedFieldName; assigned = true; break; }
      }
      if (!assigned) config.signatureField = this.selectedFieldName; // override
    }

    // Save last assigned signer ID
    this.lastAssignedSignerId = signerId;

    // Clear selected field after successful mapping
    this.selectedFieldName = null;
    this.applyVisualIndicatorsToFields();
    this.cdr.detectChanges();
  }

  cancelTextBoxAssignment() {
    this.pendingTextBoxAssignment = null;
    this.cdr.detectChanges();
  }

  /** Fill-in fields as kept on a signer: non-blank names, each listed once, with a boolean required flag.
   *  Always a fresh copy, so tag caches and payloads never share one list. */
  copyFillFields(fillFields: any): EsignFillField[] {
    if (!Array.isArray(fillFields)) return [];
    const seen = new Set<string>();
    return fillFields
      .filter((f: any) => typeof f?.name === 'string' && f.name.trim() !== '' && !seen.has(f.name) && seen.add(f.name))
      .map((f: any) => ({ name: f.name, required: f.required === true }));
  }

  /** The fillFields entry for a signer's send payload: both configs merged (the wire format keys signers by
   *  display name), or nothing when there are none, so documents without fill-in fields send as before. */
  fillFieldsPayload(existing: any, added: any): { fillFields?: EsignFillField[] } {
    const fillFields = this.copyFillFields([...(existing || []), ...(added || [])]);
    return fillFields.length > 0 ? { fillFields } : {};
  }

  getFillFields(signerId: string): EsignFillField[] {
    return this.signerFieldTags[signerId]?.fillFields || [];
  }

  toggleFillFieldRequired(signerId: string, fieldName: string) {
    const fillField = this.getFillFields(signerId).find(f => f.name === fieldName);
    if (fillField) {
      fillField.required = !fillField.required;
      this.applyVisualIndicatorsToFields();
      this.cdr.detectChanges();
    }
  }

  detachFillField(signerId: string, fieldName: string) {
    const config = this.signerFieldTags[signerId];
    if (config?.fillFields) {
      config.fillFields = config.fillFields.filter(f => f.name !== fieldName);
      this.applyVisualIndicatorsToFields();
      this.cdr.detectChanges();
    }
  }

  detachField(signerId: string, slotKey: string) {
    const config = this.signerFieldTags[signerId];
    if (config) {
      config[slotKey] = '';
      this.applyVisualIndicatorsToFields();
      this.cdr.detectChanges();
    }
  }

  toggleSignatureOptional(signerId: string, slotOptionalKey: string) {
    const config = this.signerFieldTags[signerId] as any;
    if (config) {
      config[slotOptionalKey] = !config[slotOptionalKey];
      this.applyVisualIndicatorsToFields();
      this.cdr.detectChanges();
    }
  }

  getSignatureField(signerId: string, idx: number): string {
    const key = idx === 1 ? 'signatureField' : `signatureField${idx}`;
    return this.signerFieldTags[signerId]?.[key] || '';
  }

  getDateField(signerId: string, idx: number): string {
    const key = idx === 1 ? 'dateField' : `dateField${idx}`;
    return this.signerFieldTags[signerId]?.[key] || '';
  }

  isSignatureOptional(signerId: string, idx: number): boolean {
    const key = idx === 1 ? 'signatureFieldOptional' : `signatureField${idx}Optional`;
    return !!this.signerFieldTags[signerId]?.[key];
  }

  onPatientSignatureRequiredToggle() {
    // A patient who isn't signing can't hold fields on the document (IOHB-1865).
    if (!this.isPatientSignatureRequired) {
      this.removePatientFields();
    }
    if (this.selectedTemplateToFill) {
      this.selectedTemplateToFill.isPatientSignatureRequired = this.isPatientSignatureRequired;
      this.templatePatientSigRequiredCache[this.selectedTemplateToFill.fileName] = this.isPatientSignatureRequired;
    }
    this.applyVisualIndicatorsToFields();
    this.cdr.detectChanges();
  }

  /** Clears everything given to the patient on the document being prepared (signature spots, dates and fill-in
   *  fields), so a patient who isn't signing gets no link and holds no fields that nobody would fill (IOHB-1865). */
  private removePatientFields() {
    if (this.pendingTextBoxAssignment?.signerId === 'patient') this.pendingTextBoxAssignment = null;
    const cfg: any = this.signerFieldTags?.['patient'];
    if (!cfg) return;
    let removed = cfg.fillFields?.length || 0;
    for (let idx = 1; idx <= 10; idx++) {
      const sigKey = idx === 1 ? 'signatureField' : `signatureField${idx}`;
      const dateKey = idx === 1 ? 'dateField' : `dateField${idx}`;
      const optionalKey = idx === 1 ? 'signatureFieldOptional' : `signatureField${idx}Optional`;
      if (cfg[sigKey]) { cfg[sigKey] = ''; removed++; }
      if (cfg[dateKey]) { cfg[dateKey] = ''; removed++; }
      if (cfg[optionalKey]) cfg[optionalKey] = false;
    }
    cfg.fillFields = [];
    if (removed > 0) {
      this.messageHandlerService.generateToastMessage(
        "info",
        "Patient's fields removed",
        `Removed ${removed} field${removed === 1 ? '' : 's'} from the patient, who isn't signing this document.`
      );
    }
  }

  // --- Readiness indicator (Prepare for Signing) ---
  // A signer is "ready" iff Signature Field 1 is mapped, unless the signer is the
  // patient and isPatientSignatureRequired is false (IOHB-1779).
  isSignerReady(signerId: string): boolean {
    if (signerId === 'patient' && !this.isPatientSignatureRequired) {
      return true;
    }
    return !!this.signerFieldTags[signerId]?.signatureField;
  }

  signerMappedFieldCount(signerId: string): number {
    const cfg = this.signerFieldTags[signerId];
    if (!cfg) return 0;
    let count = 0;
    for (let idx = 1; idx <= 10; idx++) {
      const key = idx === 1 ? 'signatureField' : `signatureField${idx}`;
      if (cfg[key]) count++;
    }
    return count + (cfg.fillFields?.length || 0); // plus the fields they fill in (IOHB-1779)
  }

  get esignPrepUnreadySigners(): string[] {
    const signers = this.signersForTagging || [];
    const requiredSigners = this.isPatientSignatureRequired
      ? signers
      : signers.filter(s => s.id !== 'patient');
    return requiredSigners
      .filter(s => !this.signerFieldTags[s.id]?.signatureField)
      .map(s => s.name);
  }

  get esignPrepAllReady(): boolean {
    const signers = this.signersForTagging || [];
    if (signers.length === 0) return false;
    const requiredSigners = this.isPatientSignatureRequired
      ? signers
      : signers.filter(s => s.id !== 'patient');
    if (requiredSigners.length === 0) return false;
    return requiredSigners.every(s => !!this.signerFieldTags[s.id]?.signatureField);
  }

  getViewOnlySignatureField(signer: any, idx: number): string {
    const key = idx === 1 ? 'signatureField' : `signatureField${idx}`;
    return signer?.[key] || '';
  }

  getViewOnlyDateField(signer: any, idx: number): string {
    const key = idx === 1 ? 'dateField' : `dateField${idx}`;
    return signer?.[key] || '';
  }

  onFillableFormClose() {
    this.fillableFormModalDisplay = false;
    this.esignModalDisplay = true;
    this.cdr.detectChanges();
  }

  saveAndUploadFilledPdf() {
    if (!this.originalPdfBytes || !this.selectedTemplateToFill) return;

    // Validate that every signer who requires a signature has at least a primary Signature Field mapped (IOHB-1779)
    const signers = this.getSignersForTagging();
    const requiredSigners = this.isPatientSignatureRequired
      ? signers
      : signers.filter(s => s.id !== 'patient');

    if (signers.length > 0 && requiredSigners.length === 0) {
      this.messageHandlerService.generateToastMessage(
        "warn",
        "Validation Error",
        "Please add at least one additional signer (such as a POA or Guardian) if the patient is not required to sign."
      );
      return;
    }

    const missingSig = requiredSigners.find(s => !this.signerFieldTags[s.id]?.signatureField);
    if (missingSig) {
      this.messageHandlerService.generateToastMessage("warn", "Validation Error", `Please select Signature Field 1 for ${missingSig.name}.`);
      return;
    }

    // Read remaining non-radio values from the rendered annotation layers in the DOM.
    // Radio button values are already kept in sync by real-time 'change' listeners
    // added during renderFillablePdfPages, so we skip them here to avoid overwriting
    // a cached selection with an empty or wrong DOM value.
    const inputs = document.querySelectorAll('.fillable-pdf-body .annotationLayer input, .annotationLayer textarea, .annotationLayer select');
    inputs.forEach((inputEl: any) => {
      // Skip radio buttons — handled by real-time listeners and safety net sweep
      if (inputEl.type === 'radio') return;

      // Resolve field name via annotationId map first (more reliable), then fall back to input.name
      let name = inputEl.name;
      const section = inputEl.closest('section') as HTMLElement;
      if (section) {
        const annotId = section.getAttribute('data-annotation-id');
        if (annotId && this.annotationIdToFieldNameMap[annotId]) {
          name = this.annotationIdToFieldNameMap[annotId];
        }
      }

      if (name) {
        let val: any = inputEl.value;
        const nameLower = name.toLowerCase();
        if ((nameLower.includes('date') || nameLower.includes('dob')) && val) {
          val = val.replace(/\//g, '-');
        }
        if (inputEl.type === 'checkbox') {
          // A pick-one field's value comes from the checkbox sweep below, not from each of its boxes (IOHB-1868)
          if (this.isPickOneCheckbox(name)) return;
          val = inputEl.checked;
        }

        const field = this.pdfFormFields.find(f => f.name === name);
        if (field) {
          field.value = val;
        }
      }
    });

    // Safety net: sweep all CHECKED radio inputs and capture their values.
    // This catches radios that were pre-filled by PDF.js (no 'change' event fires
    // when PDF.js sets the initial checked state from the pre-filled PDF bytes).
    const radioInputs = document.querySelectorAll('.fillable-pdf-body .annotationLayer input[type="radio"]');
    radioInputs.forEach((radioEl: any) => {
      if (!radioEl.checked) return;
      const section = radioEl.closest('section') as HTMLElement;
      const annotId = section ? section.getAttribute('data-annotation-id') : null;
      const fieldName = (annotId ? this.annotationIdToFieldNameMap[annotId] : null) || radioEl.name;
      const exportValue = (annotId ? this.annotationIdToButtonValueMap[annotId] : null) || radioEl.value || '';
      if (fieldName && exportValue) {
        const field = this.pdfFormFields.find(f => f.name === fieldName);
        if (field) {
          field.value = exportValue;
          field.type = 'radio';
        }
      }
    });

    // Safety net: sweep ALL checkbox inputs using checkboxStateMap (our own tracked state).
    // We do NOT use inputEl.checked here because PDF.js v2.x resets it after user interactions.
    const checkboxInputs = document.querySelectorAll('.fillable-pdf-body .annotationLayer input[type="checkbox"]');
    checkboxInputs.forEach((checkEl: any) => {
      const section = checkEl.closest('section') as HTMLElement;
      const annotId = section ? section.getAttribute('data-annotation-id') : null;
      const fieldName = (annotId ? this.annotationIdToFieldNameMap[annotId] : null) || checkEl.name;
      if (fieldName) {
        const field = this.pdfFormFields.find(f => f.name === fieldName);
        if (field) {
          // Prefer our own map; fall back to DOM state for pre-filled checkboxes not yet clicked
          const trackedState = this.checkboxStateMap[fieldName];
          if (trackedState !== undefined) {
            field.value = trackedState;
          } else if (!this.isPickOneCheckbox(fieldName)) {
            field.value = checkEl.checked;
          }
          field.type = 'checkbox';
        }
      }
    });

    // Text can be typed into a field after it became a signature spot, and older drafts can restore spots the
    // prepare screen now refuses, so check every mapped signature spot against the values about to be saved.
    for (const signer of signers) {
      const cfg = this.signerFieldTags[signer.id];
      if (!cfg) continue;
      for (let idx = 1; idx <= 10; idx++) {
        const fieldName = cfg[idx === 1 ? 'signatureField' : `signatureField${idx}`];
        // Date fields keep their own handling, but only a text box counts as one: a checkbox or choice field is refused
        // whatever its name (IOHB-1868).
        const isDate = this.isDateFieldName(fieldName) && this.nonSignatureFieldKinds[fieldName] === 'text box';
        const problem = fieldName && !isDate ? this.signatureSpotProblem(fieldName) : null;
        if (problem) {
          this.messageHandlerService.generateToastMessage("warn", "Not a signature field", `Signature spot for ${signer.name || 'a signer'}: ${problem}`);
          return;
        }
      }
    }

    this.savingPdfFields = true;
    this.progressBarService.setProgressBarVisibility(true);

    const PDFLib = (window as any).PDFLib;
    if (!PDFLib) {
      this.messageHandlerService.generateToastMessage("error", "Error", "PDF-lib is not loaded.");
      this.savingPdfFields = false;
      this.progressBarService.setProgressBarVisibility(false);
      return;
    }

    setTimeout(async () => {
      try {
        const pdfDoc = await PDFLib.PDFDocument.load(this.originalPdfBytes, { ignoreEncryption: true });
        const form = pdfDoc.getForm();

        // Fill fields
        this.pdfFormFields.forEach(mappedField => {
          try {
            const f = form.getField(mappedField.name);
            if (f) {
              const isRadioField = mappedField.type === 'radio';
              const hasSelectFn = typeof (f as any).select === 'function' && typeof (f as any).getOptions === 'function';

              if (isRadioField && hasSelectFn) {
                // True PDFRadioGroup — use select() with normalized option value
                if (mappedField.value) {
                  const options = (f as any).getOptions();
                  const valToSelect = options.find((opt: string) =>
                    opt === mappedField.value ||
                    opt.replace(/^\//, '') === mappedField.value ||
                    opt === `/${mappedField.value}` ||
                    opt.toLowerCase() === mappedField.value?.toLowerCase()
                  );
                  try { (f as any).select(valToSelect || mappedField.value); } catch { /* mapped value not a valid PDF option — skip (IOHB-1589 review) */ }
                  if (typeof (f as any).defaultUpdateAppearances === 'function') {
                    (f as any).defaultUpdateAppearances();
                  }
                }
              } else if (isRadioField && !hasSelectFn && typeof (f as any).check === 'function') {
                // Checkbox-backed radio (individual checkbox per option): tick the chosen option's box (IOHB-1868).
                const tickedChosenBox = typeof mappedField.value === 'string' && tickCheckBoxByExportValue(f, mappedField.value);
                if (!tickedChosenBox && mappedField.value) {
                  (f as any).check();
                } else if (!tickedChosenBox) {
                  (f as any).uncheck();
                }
                if (typeof (f as any).defaultUpdateAppearances === 'function') {
                  (f as any).defaultUpdateAppearances();
                }
              } else if (mappedField.type === 'checkbox') {
                if (typeof mappedField.value === 'string' && mappedField.value !== '') {
                  // A pick-one field: tick the box that was chosen, not the field's first box (IOHB-1868)
                  tickCheckBoxByExportValue(f, mappedField.value);
                } else if (mappedField.value) {
                  (f as any).check();
                } else {
                  (f as any).uncheck();
                }
                if (typeof (f as any).defaultUpdateAppearances === 'function') {
                  (f as any).defaultUpdateAppearances();
                }
              } else if (typeof (f as any).setText === 'function') {
                (f as any).setText(mappedField.value || '');
              } else if (typeof (f as any).select === 'function') {
                (f as any).select(mappedField.value || '');
              }
            }
          } catch (err) {
            console.warn(`Could not set field ${mappedField.name}:`, err);
          }
        });

        if (form.acroForm && form.acroForm.dict) {
          const PDFName = PDFLib.PDFName;
          const PDFBool = PDFLib.PDFBool;
          if (PDFName && PDFBool) {
            form.acroForm.dict.set(PDFName.of('NeedAppearances'), PDFBool.True);
          }
        }

        // Do NOT flatten the form fields so interactive signature markers remain active.
        // form.flatten();

        // Save PDF bytes
        const pdfBytes = await pdfDoc.save();

        // Create File object
        const originalName = this.selectedTemplateToFill.fileOriginalName || 'Document.pdf';
        const baseNameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.')) || originalName;
        const timestamp = new Date().toISOString().replace(/[:\.]/g, '-');
        const customFileName = `${baseNameWithoutExt}-filled-${timestamp}.pdf`;

        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const file = new File([blob], customFileName, { type: 'application/pdf' });

        // Build FormData
        const formData = new FormData();
        formData.append('file', file);
        formData.append('documentTypes[]', 'file');

        this.agencyService.uploadSocFile(formData).subscribe({
          next: (res) => {
            this.savingPdfFields = false;
            this.progressBarService.setProgressBarVisibility(false);
            if (res?.message?.Location) {
              // Cache the fields and tags
              this.filledFormValuesCache[this.selectedTemplateToFill.fileName] = JSON.parse(JSON.stringify(this.pdfFormFields));
              this.templateSignerTagsCache[this.selectedTemplateToFill.fileName] = JSON.parse(JSON.stringify(this.signerFieldTags));
              this.templatePatientSigRequiredCache[this.selectedTemplateToFill.fileName] = this.isPatientSignatureRequired;

              const customTemplate = {
                fileOriginalName: originalName,
                fileName: res.message.Key,
                fileLocation: res.message.Location,
                isFilledCustom: true,
                isPatientSignatureRequired: this.isPatientSignatureRequired
              };

              // Decorate the template in the selectedTemplates and esignTemplatesList
              this.selectedTemplateToFill.isPatientSignatureRequired = this.isPatientSignatureRequired;
              this.selectedTemplateToFill.filledCustomFile = customTemplate;

              // One document per request: preparing a document makes it THE single
              // selected document (replaces any prior selection).
              this.selectedTemplates = [this.selectedTemplateToFill];

              this.messageHandlerService.generateToastMessage("success", "Success", "Form pre-filled and saved successfully.");
              this.fillableFormModalDisplay = false;
              this.cdr.detectChanges();
              // Auto-save the prepared document so the mapping/prefill persists without
              // needing an explicit Save press.
              this.scheduleAutoSaveDraft();
            } else {
              this.messageHandlerService.generateToastMessage("error", "Error", "Failed to upload filled PDF: invalid response");
            }
          },
          error: (err) => {
            this.savingPdfFields = false;
            this.progressBarService.setProgressBarVisibility(false);
            this.messageHandlerService.generateToastMessage("error", "Error", "Failed to upload filled PDF: " + (err.message || err));
            this.cdr.detectChanges();
          }
        });

      } catch (err: any) {
        console.error('Error during PDF flattening and saving:', err);
        this.savingPdfFields = false;
        this.progressBarService.setProgressBarVisibility(false);
        this.messageHandlerService.generateToastMessage("error", "Error", "Failed to fill and flatten PDF: " + (err.message || err));
        this.cdr.detectChanges();
      }
    }, 50);
  }

  clearFilledPdfForm(template: any) {
    if (!template) return;
    delete template.filledCustomFile;
    delete this.filledFormValuesCache[template.fileName];
    delete this.templateSignerTagsCache[template.fileName];
    if (this.selectedTemplateToFill?.fileName === template.fileName) {
      this.signerFieldTags = {};
      this.applyVisualIndicatorsToFields();
    }
    this.messageHandlerService.generateToastMessage("info", "Cleared", "Pre-filled values cleared for this document.");
    this.cdr.detectChanges();
    // Persist the cleared state automatically (equivalent to pressing Save after clear).
    this.scheduleAutoSaveDraft();
  }

  zoomInFillablePdf() {
    if (this.fillPdfZoomScale < 2.0) {
      this.fillPdfZoomScale = Math.min(2.0, this.fillPdfZoomScale + 0.15);
      this.reRenderFillablePdfPages();
    }
  }

  zoomOutFillablePdf() {
    if (this.fillPdfZoomScale > 0.6) {
      this.fillPdfZoomScale = Math.max(0.6, this.fillPdfZoomScale - 0.15);
      this.reRenderFillablePdfPages();
    }
  }

  resetZoomFillablePdf() {
    if (this.fillPdfZoomScale !== 1.0) {
      this.fillPdfZoomScale = 1.0;
      this.reRenderFillablePdfPages();
    }
  }

  reRenderFillablePdfPages() {
    // If a render is already in flight, defer instead of forcing an overlapping render;
    // the in-flight render's finally block will pick up the latest zoom scale.
    if (this.renderingPdfPages) {
      this.pendingReRender = true;
      return;
    }
    this.renderFillablePdfPages();
  }

  getZoomPercent(): string {
    return Math.round(this.fillPdfZoomScale * 100) + '%';
  }
}
